// zu — checkin/quickCheck/stepTracker blocks translated.
export const zu = {
  "common": {
    "loading": "Iyalayisha...",
    "save": "Londoloza",
    "cancel": "Khansela",
    "delete": "Susa",
    "edit": "Hlela",
    "close": "Vala",
    "confirm": "Qinisekisa",
    "back": "Emuva",
    "next": "Okulandelayo",
    "submit": "Thumela",
    "search": "Funa",
    "select": "Khetha",
    "or": "Noma",
    "and": "futhi",
    "note": "Phawula",
    "viewAll": "Buka Konke",
    "learnMore": "Funda kabanzi",
    "getStarted": "Qalisa",
    "continue": "Qhubeka",
    "saving": "Iyalondoloza…"
  },
  "nav": {
    "dashboard": "Ekhaya",
    "nutrition": "Ezomsoco",
    "family": "Umndeni",
    "care": "Izinsiza",
    "careShort": "Izinsiza",
    "checkIn": "Ukuhlola",
    "insights": "Ulwazi",
    "trends": "Imikhuba",
    "habits": "Izinto ozenzayo",
    "medications": "Imithi",
    "expertSupport": "Ukwesekwa Kochwepheshe",
    "profile": "Iphrofayili",
    "healthHub": "Isizinda Sezempilo",
    "support": "Ukwesekwa",
    "wellness": "Inhlalakahle",
    "education": "Imfundo",
    "community": "Umphakathi",
    "preventiveHealth": "Ukuvikeleka kwezempilo",
    "womensHealth": "Impilo Yabesifazane",
    "reminders": "Izikhumbuzi Zezeempilo",
    "meals": "Ukudla",
    "orders": "Ama-oda",
    "subscription": "Ukubhalisa",
    "logout": "Phuma"
  },

  "navShort": {
    "dashboard": "Ikhaya",
    "nutrition": "Ukudla",
    "family": "Umndeni",
    "care": "Izinsiza",
    "support": "Usizo",
    "profile": "Iphrofayili"
  },
  "auth": {
    "login": "Ngena",
    "register": "Vula i-akhawunti",
    "logout": "Phuma",
    "email": "I-imeyili",
    "password": "Iphasiwedi",
    "name": "Igama Eliphelele",
    "forgotPassword": "Ukhohlwe iphasiwedi?",
    "noAccount": "Awunayo i-akhawunti?",
    "haveAccount": "Usuvele unayo i-akhawunti?",
    "signInHere": "Ngena lapha",
    "signUpHere": "Bhalisa lapha",
    "welcomeBack": "Siyakwamukela futhi!",
    "getStarted": "Asiqale",
    "biometricLogin": "Ngena nge-Biometrics",
    "biometricHelper": "Sebenzisa iminwe, i-Face ID, noma i-Windows Hello",
    "vendorLogin": "Ukungena Komthengisi",
    "createOne": "Yakha entsha",
    "tagline": "Hlala uphambili ngezempilo yakho — ngokuhlola okukodwa okulula nsuku zonke.",
    "takes30s": "Thatha isikhathi esingaphansi kwemizuzwana engu-30",
    "emailPlaceholder": "wena@isibonelo.com",
    "passwordPlaceholder": "Faka iphasiwedi yakho",
    "checking": "Iyayihlola…",
    "continue": "Qhubeka",
    "secureMessage": "Kuphephile futhi kuyimfihlo — idatha yakho ivikelekile",
    "biometricSoon": "Ukungena nge-Biometric — Kuyaza Maduze",
    "sessionExpired": "Isikhathi sakho siphelile. Sicela ungene futhi ukuze uqhubeke lapho ugcine khona.",
    "showPassword": "Khombisa iphasiwedi",
    "hidePassword": "Fihla iphasiwedi",
    "vendor": {
      "title": "Ukungena Kozakwethu Abadayisayo",
      "subtitle": "Finyelela kudeshibhodi yakho yokudayisa ye-HealthLoop",
      "businessEmail": "I-imeyili yebhizinisi",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Iyangena...",
      "signIn": "Ngena",
      "notVendorYet": "Awukabi nguye ozakwethu odayisayo?",
      "registerBusiness": "Bhalisa ibhizinisi lakho",
      "areYouUser": "Ungumsebenzisi?",
      "userLogin": "Ukungena komsebenzisi",
      "welcomeBackToast": "Siyakwamukela futhi!",
      "genericError": "Ukungena kuhlulekile. Sicela uzame futhi."
    },
    "admin": {
      "backToUserLogin": "Ukungena komsebenzisi",
      "title": "Ukungena koMlawuli",
      "restrictedBadge": "Kuvunyelwe abathile",
      "tagline": "Ikhonsoli yomsebenzisi we-HealthLoop — kudingeka imininingwane yomlawuli.",
      "emailLabel": "I-imeyili yomlawuli",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "Iphasiwedi",
      "passwordPlaceholder": "Faka iphasiwedi yakho yomlawuli",
      "signingIn": "Iyangena…",
      "submit": "Ngena kukhonsoli yomlawuli",
      "secureNote": "Uxhumano luphephile · iseshini ifihliwe",
      "restrictedTitle": "Le ndawo ivunyelwe abalawuli kuphela.",
      "restrictedBody": "I-akhawunti yakho ingenile, kodwa ayinayo imvume yomlawuli. Phuma ukuze uzame i-akhawunti ehlukile, noma ubuyele kuhlelo lokusebenza oluyinhloko.",
      "signOut": "Phuma",
      "backToApp": "Buyela kuhlelo lokusebenza"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Uzizwa kanjani namuhla?",
      "subtitle": "Ukuhlola okusheshayo — kuthatha imizuzwana engaphansi kwengama-60"
    },
    "section1": {
      "title": "Yini oyiphaphelayo namuhla?",
      "hint": "(Khetha konke okukhona)"
    },
    "environment": {
      "title": "Indawo okuyo namuhla",
      "hint": "Siza usisize siqonde indawo okuyo"
    },
    "basicChecks": {
      "title": "Ukuhlola okulula okusheshayo",
      "hint": "Akukho nkani kodwa kuyasiza"
    },
    "validation": {
      "pickOne": "Sicela uphendule okungenani umbuzo owodwa"
    },
    "submit": {
      "cta": "Thola Ulwazi Lwami Lwezempilo",
      "saving": "Iyalondoloza...",
      "analyzing": "Sihlaziya amaphethini akho ezempilo...",
      "savedToast": "✅ Ukuzihlola kulondoloziwe! Sihlaziya amaphethini akho ezempilo..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Isilinganisi-zinyathelo",
      "subtitle": "Ukulandela umsebenzi womzimba ngeqiniso",
      "backToDashboard": "Buyela kudeshibhodi"
    },
    "today": {
      "title": "Izinyathelo zanamuhla",
      "goalProgress": "{{current}} / {{goal}} izinyathelo",
      "goalReached": "Umshado ufinyelelwe — umsebenzi omuhle!",
      "keepGoing": "Qhubeka njalo — usendleleni efanele."
    },
    "streak": {
      "label": "Izinsuku ezilandelanayo",
      "days": "Usuku olu-{{count}}",
      "daysPlural": "Izinsuku ezi-{{count}}"
    },
    "badges": {
      "title": "Amabheji",
      "empty": "Uzothola amabheji njengoba wakha lo mkhuba."
    },
    "reminders": {
      "title": "Izikhumbuzi zokunyakaza",
      "hint": "Izikhumbuzi ezithambile zokuhamba kancane lapho uhleli isikhathi eside.",
      "enabled": "Kuvuliwe",
      "disabled": "Kuvaliwe"
    },
    "insights": {
      "weeklyAverage": "Isilinganiso seviki",
      "weeklyGoal": "Umgomo weviki"
    },
    "actions": {
      "connect": "Xhuma umthombo wezinyathelo",
      "manualLog": "Faka izinyathelo ngesandla",
      "changeGoal": "Shintsha umgomo wosuku"
    }
  },
  "checkin": {
    "header": {
      "title": "Ukuzihlola Kwempilo Kwansuku Zonke",
      "subtitle": "Kuthatha isikhathi esingaphansi kwemizuzwana engama-60",
      "restDayLink": "Angizizwa kahle namuhla"
    },
    "snapshot": {
      "title": "Ideshibhodi yakho, ibuyekeziwe",
      "healthScore": "Amaphuzu ezempilo",
      "todayTasks": "Imisebenzi yanamuhla",
      "dayStreak": "izinsuku zilandelana"
    },
    "resume": {
      "banner": "Uqhubeke lapho ugcine khona",
      "startFresh": "Qala kabusha",
      "dismiss": "Susa"
    },
    "progress": {
      "allSet": "Konke sekulungile",
      "step": "Isinyathelo {{current}} koku {{total}}",
      "ariaLabel": "Ukuzihlola kwansuku zonke: {{done}} kwezigaba eziyi-{{total}} sekuphothuliwe"
    },
    "insights": {
      "title": "Ulwazi Ngempilo Yakho",
      "subtitle": "Okwenzelwe wena namuhla",
      "insightForYou": "Ulwazi lwakho",
      "simpleActions": "Izinto ezilula ongazenza",
      "whenToSeekHelp": "Isikhathi sokufuna usizo",
      "nhsAdvice": "Uma ukhathazekile, thintana ne-NHS 111 noma udokotela wakho",
      "backToDashboard": "Buyela kudeshibhodi",
      "newCheckIn": "Ukuzihlola Okusha",
      "disclaimer": "I-HealthLoop inikeza iseluleko, hhayi ukuxilongwa kwesifo."
    },
    "restDay": {
      "title": "Ukuphumula kuyingxenye yohlelo.",
      "body": "Sizobe sikhona kusasa, lapho nawe usulungele.",
      "streakNote": "Izinsuku zakho ezilandelanayo azinyakazanga — nazo zisaphumule.",
      "backToDashboard": "Buyela kudeshibhodi",
      "changedMind": "Eqinisweni, ngifuna ukuzihlola noma kunjalo."
    },
    "feelings": {
      "title": "Uzizwa kanjani namuhla?",
      "hint": "Khetha konke okukuthintayo",
      "tired": "Ngizizwa ngikhathele",
      "headache": "Ikhanda elibuhlungu",
      "stressed": "Ngicindezelekile noma ngikhungathekile",
      "pain": "Ubuhlungu emzimbeni",
      "okay": "Ngizizwa kahle namuhla"
    },
    "basics": {
      "title": "Izinto ezisisekelo",
      "sleepQ": "Ulale kahle yini izolo ebusuku?",
      "waterQ": "uphuze amanzi anele yini namuhla?",
      "foodQ": "Udlile kahle yini namuhla?",
      "activityQ": "Ubusebenza kangakanani namuhla?",
      "yes": "Yebo",
      "notReally": "Hhayi kahle",
      "notYet": "Hhayi okwamanje",
      "notActive": "Bengingenzi lutho",
      "lightActivity": "Imisebenzi elula",
      "active": "Ngisebenze kakhulu"
    },
    "mind": {
      "title": "Ingqondo namandla",
      "stressQ": "Linjani izinga lakho lokucindezeleka namuhla?",
      "moodQ": "Injani imizwa yakho namuhla?",
      "energyQ": "Linjani izinga lakho lamandla namuhla?",
      "low": "Liphansi",
      "moderate": "Liphakathi nendawo",
      "high": "Liphakeme",
      "neutral": "Ngizizwa nginjalo nje",
      "good": "Kuhle",
      "okay": "Kulungile"
    },
    "day": {
      "title": "Usuku lwakho",
      "routineQ": "Ulandele uhlelo lwakho olujwayelekile yini namuhla?",
      "yes": "Yebo",
      "no": "Cha"
    },
    "environment": {
      "title": "Indawo okuyo namuhla",
      "describeQ": "Ungayichaza kanjani indawo okuyo?",
      "comfortable": "😊 Inethezekile",
      "slightlyUncomfortable": "😐 Ayikho kahle kancane",
      "challenging": "😓 Inzima",
      "affectedQ": "Ingabe indawo okuyo iyithintile indlela ozizwa ngayo?",
      "yes": "Yebo",
      "no": "Cha",
      "exposureLabel": "Okuhlangabezane nakho (khetha konke okukhona)",
      "heat": "🌡️ Ukushisa",
      "cold": "❄️ Amakhaza",
      "noise": "🔊 Umsindo",
      "dustSmoke": "💨 Utshuli noma intuthu",
      "crowded": "👥 Indawo ephitheneyo",
      "none": "✅ Akukho"
    },
    "submit": {
      "analyzing": "Sihlaziya amaphethini akho ezempilo...",
      "cta": "Bona Ulwazi Lwami Lwezempilo"
    },
    "toast": {
      "savedFull": "Ukuzihlola kulondoloziwe! Ideshibhodi yakho ibuyekeziwe.",
      "savedShort": "Ukuzihlola kulondoloziwe."
    }
  },
  "onboarding": {
    "welcome": "Siyakwamukela",
    "completeSetup": "Qedela ukulungisa",
    "stepProgress": "Isinyathelo sesi-{{step}} kwizingu-{{total}}",
    "percentComplete": "Sekuqediwe u-{{percent}}%",
    "welcomeToast": "Siyakwamukela ku-HealthLoop! Iphrofayili yakho isilungile.",
    "errorAgeRange": "Sicela ukhethe iminyaka yakho",
    "errorCountry": "Sicela ukhethe izwe lakini",
    "errorGoal": "Sicela ukhethe umgomo wakho oyinhloko wezempilo",
    "errorCuisine": "Sicela ukhethe okungenani uhlobo olulodwa lokudla oluthandayo",
    "errorGeneric": "Yehlulekile ukuqedela ukubhalisa. Sicela uzame futhi.",
    "step1Title": "Siyakwamukela ku-HealthLoop! 👋",
    "step1Subtitle": "Asenze uhambo lwakho lwezempilo lufanele wena",
    "ageRangeLabel": "Ungena kuluphi ukhululo lweminyaka?",
    "genderLabel": "Ubulili (Akuphoqelekile)",
    "gender_male": "Owesilisa",
    "gender_female": "Owesifazane",
    "gender_non-binary": "Okunye",
    "gender_prefer_not_to_say": "Ngikhetha ukungasho",
    "step2Title": "Uzinze kuphi? 🌍",
    "step2Subtitle": "Lokhu kusisiza ukuba siphakamise ukudla okuhambisana nesiko lakini",
    "countryLabel": "Khetha izwe lakini",
    "country_uk": "E-United Kingdom",
    "country_nigeria": "E-Nigeria",
    "country_ghana": "E-Ghana",
    "country_kenya": "E-Kenya",
    "country_south_africa": "E-Ningizimu Afrika",
    "country_usa": "E-United States",
    "country_canada": "E-Canada",
    "country_india": "E-India",
    "country_jamaica": "E-Jamaica",
    "country_other": "Okunye",
    "step3Title": "Uyini umgomo wakho oyinhloko? 🎯",
    "step3Subtitle": "Khetha inhloso yakho enkulu yezempilo",
    "additionalGoals": "Eminye imigomo? (Akuphoqelekile)",
    "goal_weight_loss": "Ukwehlisa isisindo",
    "goalDesc_weight_loss": "Yehlisa isisindo ngendlela enempilo",
    "goal_weight_maintenance": "Ukugcina isisindo",
    "goalDesc_weight_maintenance": "Hlala kulesi sisindo onaso manje",
    "goal_muscle_gain": "Ukwakha imisipha",
    "goalDesc_muscle_gain": "Thola amandla nemisipha",
    "goal_general_wellness": "Inhlalakahle nje",
    "goalDesc_general_wellness": "Ukuthuthukisa impilo yonkana",
    "goal_better_sleep": "Ukulala kangcono",
    "goalDesc_better_sleep": "Thuthukisa indlela olala ngayo",
    "goal_reduce_stress": "Ukunciphisa ukucindezeleka",
    "goalDesc_reduce_stress": "Phatha ukucindezeleka kangcono",
    "goal_increase_energy": "Amandla engeziwe",
    "goalDesc_increase_energy": "Zizwe unamandla amaningi",
    "step4Title": "Okuthandwayo ekudleni 🍽️",
    "step4Subtitle": "Khetha ukudla okujabulelayo nanoma yikuphi ongakudli",
    "cuisineLabel": "Ukudla okuthandayo",
    "cuisineHint": "Khetha okungenani okukodwa (ungakhetha amaningi)",
    "dietaryLabel": "Izinto ongazidli (Akuphoqelekile)",
    "diet_vegetarian": "Okungadli inyama",
    "diet_vegan": "Okungadli imikhiqizo yezilwane",
    "diet_halal": "I-Halal",
    "diet_kosher": "I-Kosher",
    "diet_gluten_free": "Okungenayo i-Gluten",
    "diet_dairy_free": "Okungenayo imikhiqizo yobisi",
    "diet_pescatarian": "Okudla inhlanzi kuphela",
    "step5Title": "Isimo sezempilo 🏥",
    "step5Subtitle": "Akuphoqelekile — kusisiza ukukunikeza izeluleko ezingcono",
    "conditionsLabel": "Ingabe unayo enye yalezi zimo zezempilo?",
    "conditionsHint": "Lolu lwazi luyimfihlo futhi lusiza ekwenzeni lolu hlelo lusebenze kahle kuwe",
    "condition_diabetes": "Isifo sikashukela",
    "condition_hypertension": "Umfutho wegazi ophezulu",
    "condition_heart_disease": "Isifo senhliziyo",
    "condition_thyroid": "Izinkinga ze-Thyroid",
    "condition_celiac": "Isifo se-Celiac",
    "condition_ibs": "I-IBS",
    "condition_none": "Akukho",
    "privacyTitle": "Idatha yakho ivikelekile",
    "privacyBody": "Imininingwane yakho ibhalwe ngendlela eyimfihlo futhi igcinwe ngokuphepha. Sisebenzisa le datha kuphela ukuze sikunikeze ukudla okufanele wena, amathiphu ezempilo, kanye nezaziso. Idatha yakho ayisoze yabiwa nabanye ngaphandle kwemvume yakho ecacile.",
    "trackMedication": "Ngifuna ukulandelela imithi yami",
    "specialistInterest": "Nginentshisekelo yokubonana nochwepheshe",
    "welcomeTitle": "Siyakwamukela ku-HealthLoop! 👋",
    "welcomeSubtitle": "Masenze ngezifiso ubuhlakani bakho be-AI bezempilo nendlela yokuphila ngezinyathelo ezimbalwa ezilula",
    "stepLabel": "Isinyathelo {{current}} koku {{total}}",
    "skipForNow": "Yeqa okwamanje",
    "skipToast": "Ungaqedela ukusetha noma nini kuphrofayela yakho",
    "back": "Emuva",
    "next": "Okulandelayo",
    "completing": "Iyaqedela...",
    "complete": "Qedela Ukusetha",
    "successToast": "Siyakwamukela ku-HealthLoop! Iphrofayela yakho isilungisiwe 🎉",
    "failureToast": "Kuhlulekile ukuqedela ukusetha",
    "validation": {
      "basicInfo": "Sicela ugcwalise yonke imininingwane eyisisekelo",
      "pickGoal": "Sicela ukhethe okungenani umgomo owodwa wezempilo",
      "pickPrimary": "Sicela ukhethe umgomo wakho oyinhloko",
      "pickRegion": "Sicela ukhethe isifunda sakho samasiko ukuze uthole iziphakamiso zokudla",
      "pickFocus": "Sicela ukhethe okugxile kakhulu kukho kwezempilo"
    },
    "step1": {
      "title": "Iphrofayela Yakho Yezempilo",
      "description": "Siza sakhe ubuhlakani bakho be-AI bezempilo obenzelwe wena",
      "age": "Iminyaka *",
      "agePlaceholder": "isib., 30",
      "height": "Ubude (cm) *",
      "heightPlaceholder": "isib., 170",
      "weight": "Isisindo (kg) *",
      "weightPlaceholder": "isib., 70"
    },
    "step2": {
      "title": "Imigomo Yakho Yezempilo",
      "description": "Khetha konke okusebenzayo, bese ukhetha umgomo wakho oyinhloko",
      "primaryLabel": "Khetha Umgomo Wakho Oyinhloko *",
      "primaryBadge": "Oyinhloko"
    },
    "step3": {
      "title": "🌍 Amasiko Nezimfuno Zokudla",
      "description": "Siza senze ngezifiso iziphakamiso zakho zokudla",
      "regionLabel": "Isifunda Samasiko *",
      "regionHint": "Khetha isiko lakho ukuze uthole iziphakamiso zokudla ezikufanele",
      "countryLabel": "Izwe (Ungazikhethela)",
      "countryPlaceholder": "isib., Nigeria, Kenya, Jamaica",
      "countryHint": "Ukuze uthole iziphakamiso ezenziwe ngezifiso kakhulu",
      "foodPrefLabel": "Ukukhetha Ukudla Okuhlukahlukene"
    },
    "step4": {
      "title": "Okugxilwe Kakhulu Kukho",
      "description": "Khetha indawo ofuna ukugxila kuyo kakhulu"
    },
    "step5": {
      "title": "Izinto Ozithandayo",
      "description": "Lungisa indlela ofuna i-HealthLoop isebenze ngayo",
      "trackMeds": "Landelela Imithi",
      "trackMedsHint": "Vumela ukulandelwa kwemithi nezikhumbuzi ekuhloleni kwakho kwansuku zonke",
      "specialist": "Unentshisekelo Kokusekelwa Ochwepheshe",
      "specialistHint": "Thola ukufinyelela kochwepheshe bezempilo, abeluleki bezokudla, kanye nochwepheshe bezempilo yengqondo",
      "confidentialTitle": "Ukwesekwa Okuyimfihlo:",
      "confidentialBody": "Yonke imininingwane yakho ivikelekile futhi isetshenziselwa kuphela ukuhlinzeka ngemininingwane yezempilo evikelayo eyenzelwe wena."
    },
    "step6": {
      "title": "Ukwenza Ukudla Kube Ngokwakho",
      "description": "Siza siphakamise ukudla okuhambisana nokuthandayo kanye nezidingo zakho zokudla",
      "cuisinesLabel": "Ukudla Okuthandayo (Ungazikhethela)",
      "cuisinesHint": "Khetha izinhlobo zokudla ozithanda kakhulu",
      "dietaryLabel": "Imikhawulo Yokudla (Ungazikhethela)",
      "dietaryHint": "Khetha noma yikuphi okusebenzayo kuwe",
      "allergiesLabel": "Izinto Ongezwani Nazo (Ungazikhethela)",
      "allergiesHint": "Khetha noma yikuphi ukudla ongezwani nakho",
      "personalisedTitle": "Ukudla Okwenzelwe Wena:",
      "personalisedBody": "Sizosebenzisa lezi zimfuno ukuphakamisa ukudla okuhambisana nokuthandayo. Ungakwazi ukubuyekeza lokhu kamuva kuzilungiselelo."
    },
    "healthGoals": {
      "better_sleep": "Ukulala Okungcono",
      "reduce_stress": "Nciphisa Ukucindezeleka",
      "increase_energy": "Khulisa Amandla",
      "weight_management": "Phatha Isisindo",
      "improve_fitness": "Thuthukisa Ukuzivivinya",
      "better_nutrition": "Ukudla Okunempilo",
      "mental_wellness": "Inhlalakahle Yengqondo",
      "chronic_condition": "Phatha Isimo Sezempilo"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Ezempilo Yengqondo",
        "description": "Gxila emoyeni, ekucindezelekeni, nasekuphileni kahle ngokomzwelo"
      },
      "physical_fitness": {
        "label": "Ukuvivinya Umzimba",
        "description": "Gxila ekuzivivinyeni, emandleni, kanye nokusebenza komzimba"
      },
      "nutrition": {
        "label": "Ezokudla",
        "description": "Gxila ekudleni nasekudleni okunempilo"
      },
      "sleep": {
        "label": "Izinga Lokulala",
        "description": "Gxila ekuphumuleni nasekulaleni kahle"
      },
      "stress_management": {
        "label": "Ukuphatha Ukucindezeleka",
        "description": "Gxila ekuphumuleni nasekunciphiseni ukucindezeleka"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Ntshonalanga Afrika",
        "description": "Ukudla kwase-Nigeria, Ghana, nase-Senegal"
      },
      "east_african": {
        "label": "Mpumalanga Afrika",
        "description": "Ukudla kwase-Kenya, Ethiopia, nase-Tanzania"
      },
      "north_african": {
        "label": "Nyakatho Afrika",
        "description": "Ukudla kwase-Morocco nase-Egypt"
      },
      "southern_african": {
        "label": "Ningizimu Afrika",
        "description": "Ukudla kwase-Ningizimu Afrika"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Ukudla kwase-Jamaica, Trinidad, nase-Barbados"
      },
      "middle_eastern": {
        "label": "Middle Eastern",
        "description": "Ukudla kwase-Lebanon, Palestine, nase-Syria"
      },
      "south_asian": {
        "label": "Ningizimu ye-Asia",
        "description": "Ukudla kwase-India, Pakistan, nase-Bangladesh"
      },
      "east_asian": {
        "label": "Mpumalanga ye-Asia",
        "description": "Ukudla kwase-China, Japan, nase-Korea"
      },
      "southeast_asian": {
        "label": "Ningizimu-mpumalanga ye-Asia",
        "description": "Ukudla kwase-Thailand, Vietnam, nase-Indonesia"
      },
      "western": {
        "label": "Ntshonalanga",
        "description": "Ukudla kwase-America nase-Europe"
      },
      "latin_american": {
        "label": "Latin American",
        "description": "Ukudla kwase-Mexico, Brazil, nase-Argentina"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Ukudla kwase-Greece, Italy, nase-Spain"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Okosiko",
        "description": "Kakhulu ukudla okuvela esifundeni sakho samasiko"
      },
      "mixed": {
        "label": "Okuxubile",
        "description": "Ukulinganisela phakathi kokudla kwasekhaya nokwamazwe ngamazwe"
      },
      "international": {
        "label": "Okwasemazweni",
        "description": "Izinhlobo ezahlukene zokudla zomhlaba"
      }
    },
    "cuisines": {
      "west_african": "West African",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asian",
      "western": "Western",
      "indian": "Indian",
      "middle_eastern": "Middle Eastern",
      "general": "Konke Ukudla"
    },
    "dietary": {
      "vegetarian": "Vegetarian",
      "vegan": "Vegan",
      "pescatarian": "Pescatarian",
      "gluten_free": "Akuna-Gluten",
      "dairy_free": "Akuna-Dairy",
      "low_carb": "I-Low-Carb"
    },
    "allergies": {
      "nuts": "Amantongomane",
      "shellfish": "Izinhlanzi Ezinegobolondo",
      "dairy": "Imikhiqizo Yobisi",
      "eggs": "Amaqanda",
      "soy": "I-Soy",
      "gluten": "I-Gluten"
    },
    "cuisine_nigerian": "isi-Nigeria",
    "cuisine_ghanaian": "isi-Ghana",
    "cuisine_senegalese": "isi-Senegal",
    "cuisine_kenyan": "isi-Kenya",
    "cuisine_ethiopian": "isi-Ethiopia",
    "cuisine_moroccan": "isi-Morocco",
    "cuisine_south_african": "isi-Ningizimu Afrika",
    "cuisine_jamaican": "isi-Jamaica",
    "cuisine_trinidadian": "isi-Trinidad",
    "cuisine_lebanese": "isi-Lebanon",
    "cuisine_turkish": "isi-Turkey",
    "cuisine_greek": "isi-Greece",
    "cuisine_italian": "isi-Italy",
    "cuisine_french": "isi-France",
    "cuisine_british": "isi-Britain",
    "cuisine_indian_south": "isi-India yaseningizimu",
    "cuisine_indian_north": "isi-India yasenyakatho",
    "cuisine_pakistani": "isi-Pakistan",
    "cuisine_japanese": "isi-Japan",
    "cuisine_chinese": "isi-China",
    "cuisine_korean": "isi-Korea",
    "cuisine_vietnamese": "isi-Vietnam",
    "cuisine_thai": "isi-Thailand",
    "cuisine_filipino": "isi-Philippines",
    "cuisine_american": "isi-Melika",
    "cuisine_mexican": "isi-Mexico",
    "cuisine_brazilian": "isi-Brazil",
    "cuisine_peruvian": "isi-Peru"
  },
  "dashboard": {
    "welcome": "Siyakwamukela futhi",
    "greeting": "Sawubona",
    "goodMorning": "Sawubona",
    "goodAfternoon": "Sawubona",
    "goodEvening": "Sawubona",
    "tagline": "Izinyathelo ezincane ezinempilo zidala ushintsho oluhlala njalo",
    "microcopy": "Uhambo lwakho lwenhlalakahle lubalulekile.",
    "welcomeSubtitleMorning1": "Isiqalo sosuku esipholile.",
    "welcomeSubtitleMorning2": "Siyajabula ukuthi usivakashele namhlanje ekuseni.",
    "welcomeSubtitleMorning3": "Izikhathi ezincane ziba yinto enkulu.",
    "welcomeSubtitleAfternoon1": "Sithemba ukuthi usuku lwakho luhamba kahle.",
    "welcomeSubtitleAfternoon2": "Siyakwamukela futhi ku-HealthLoop.",
    "welcomeSubtitleAfternoon3": "Thatha umoya — wenza kahle.",
    "welcomeSubtitleEvening1": "Siphumula nawe.",
    "welcomeSubtitleEvening2": "Ukuphela kosuku okumnene.",
    "welcomeSubtitleEvening3": "Siyakwamukela futhi kulobu busuku.",
    "title": "Ingosi Yakho Yokuqonda Ukuvikeleka Kwezempilo",
    "subtitle": "Landelela, funda, futhi uthathe isinyathelo ngaphambi kokuba izinkinga zikhule",
    "summary": "Isifinyezo Sokuhlakanipha Kwezempilo",
    "summaryDesc": "Ulwazi lwesikhathi sangempela mayelana nokuvimbela, imfundo, nokunakekela",
    "comprehensiveSupport": "Ukwesekwa okuphelele ekuvikeleni, ekufundiseni, nasekusebenzeni kahle komzimba",
    "todayCheckIn": "Ukuhlola kwanamuhla",
    "quickActions": "Izenzo ezisheshayo",
    "healthOverview": "Isiboniso sezempilo",
    "recentActivity": "Okwenziwe muva nje",
    "viewAll": "Buka Konke",
    "preventiveHealth": "Ukuvikeleka kwezempilo",
    "preventiveHealthDesc": "Ukulandelela kwansuku zonke, ukuqapha inhlalakahle nezixwayiso",
    "education": "Imfundo",
    "educationDesc": "Ulwazi lwangempela, izihloko zezempilo nezeluleko zochwepheshe",
    "engagement": "Ukuzibandakanya",
    "engagementDesc": "Izinselelo zomphakathi, ukulandelela imikhuba nokwesekwa",
    "wellness": "Inhlalakahle",
    "wellnessDesc": "Ezomsoco, ukulinganisela indlela yokuphila nempilo yonkana",
    "todaysInsight": "Ulwazi lwanamuhla",
    "wellnessScore": "Amaphuzu enhlalakahle",
    "healthStreak": "Ukuhambisana kwezempilo",
    "days": "izinsuku",
    "logHealth": "Bhala ngezempilo",
    "getEducated": "Funda",
    "communityChallenge": "Inselelo yomphakathi",
    "checkWellness": "Hlola inhlalakahle",
    "verified": "Kuqinisekisiwe",
    "joinCommunity": "Joyina umphakathi",
    "personalizedPlan": "Uhlelo lwakho",
    "score": "Amaphuzu",
    "checkIns": "ukuhlola",
    "habits": "imikhuba",
    "preventive": "Ukuvimbela",
    "healthMetrics": "Izilinganiso zezempilo",
    "trackMetrics": "Landelela izilinganiso",
    "startTracking": "Qala ukulandelela",
    "logMetrics": "Bhala izilinganiso",
    "dailyInsight": "Ulwazi lwansuku zonke",
    "learnAbout": "Funda ngokuvikela izifo namuhla",
    "articlesAvailable": "izihloko ezikhona",
    "browseArticles": "Funda izihloko",
    "currentStreak": "Uhambo lwamanje",
    "keepGoing": "Qhubeka njalo!",
    "startStreak": "Qala uhambo lwakho",
    "checkIn": "Hlola",
    "nutritionPlan": "Uhlelo lwezomsoco",
    "mealsPlanned": "ukudla okuhleliwe",
    "viewPlan": "Buka uhlelo",
    "planYourWeek": "Hlela iviki lakho",
    "moodStress": "Imizwa Nokucindezeleka",
    "howFeeling": "Uzizwa kanjani?",
    "logWellness": "Bhala ngenhlalakahle",
    "medications": "Imithi",
    "noMeds": "Ayikho imithi elandelelwayo",
    "addMedications": "Faka imithi yakho",
    "daysTracked": "Izinsuku ezilandelelwe",
    "noHabits": "Ayikho imikhuba okwamanje",
    "startTrackingHabits": "Qala ukulandelela imikhuba",
    "insights": "Ulwazi",
    "noInsights": "Alukho ulwazi okwamanje",
    "completeFirstPlan": "Qedela uhlelo lwakho lokuqala",
    "noCheckIns": "Akukaze kuhlolwe okwamanje",
    "startFirstCheckIn": "Qala ukuhlola kwakho kokuqala"
  },
  "support": {
    "title": "Ukwesekwa",
    "subtitle": "Thola izimpendulo, xhumana nathi, noma ubike inkinga",
    "backToSettings": "Buyela kuzilungiselelo",
    "privacyBanner": "Izicelo zokusekelwa ziphathwa ngasese nangokuphephile. Imininingwane yakho yezempilo ihlala iyimfihlo.",
    "section1": "Ingxenye 1",
    "section2": "Ingxenye 2",
    "section3": "Ingxenye 3",
    "section4": "Ingxenye 4",
    "navHelpCenter": "Isizinda Sosizo",
    "navContact": "Xhumana nokwesekwa",
    "navHealth": "Izinsiza Zezempilo",
    "navTechnical": "Ukwesekwa kwezobuchwepheshe",
    "helpCenterTitle": "Isizinda Sosizo",
    "helpCenterSubtitle": "Funa imibuzo evamile futhi uthole izimpendulo ezisheshayo.",
    "contactTitle": "Xhumana nokwesekwa",
    "contactSubtitle": "Finyelela ithimba lethu ngendlela oyithandayo.",
    "healthServicesTitle": "Izinsiza Zezempilo",
    "healthServicesSubtitle": "Xhuma nokulandelwa kwemithi kanye nochwepheshe.",
    "technicalTitle": "Ukwesekwa kwezobuchwepheshe",
    "technicalSubtitle": "Bika amaphutha ohlelo ngokunikeza imininingwane egcwele.",
    "searchPlaceholder": "Funa imibuzo evamile…",
    "liveChat": "Ingxoxo ebukhoma",
    "emailUs": "Sibhalele i-imeyili",
    "callBack": "Hlela ukushayelwa ucingo",
    "sendMessage": "Thumela umlayezo",
    "medicationTracking": "Ukulandelela imithi",
    "specialistAccess": "Ukubonana nochwepheshe",
    "videoConsultation": "Ukubonana ngevidiyo",
    "reportBug": "Bika iphutha lohlelo",
    "yourName": "Igama lakho",
    "yourEmail": "I-imeyili yakho",
    "subject": "Isihloko",
    "message": "Umlayezo",
    "phone": "Ucingo",
    "description": "Incazelo",
    "submit": "Thumela",
    "successTitle": "Umlayezo uthunyelwe",
    "successDescription": "Sizophendula phakathi kwamahora angu-24–48.",
    "healthDisclaimer": "Ezimeni eziphuthumayo zezempilo, xhumana nabosizo oluphuthumayo lendawo yakini. I-HealthLoop ayithathi indawo yokunakekelwa ochwepheshe bezempilo."
  },
  "nutrition": {
    "smartNutrition": "Ezomsoco Ezihlakaniphile",
    "basedOnGoal": "Ngokusekelwe emgomweni wakho:",
    "personalizedData": "Kuhlelelwe wena ngokusekelwe kudatha yakho yezempilo yakamuva",
    "evidenceBased": "Ezomsoco ezisekelwe ebufakazeni njengengxenye yohlelo lwakho lokuvikela izifo",
    "todaysMealSuggestions": "Iziphakamiso Zokudla Kwenamuhla",
    "customize": "Yenza ngendlela yakho",
    "breakfast": "Ibhulakufesi",
    "lunch": "Ithina",
    "dinner": "Isidlo sakusihlwa",
    "loadingBreakfast": "Iyalayisha ibhulakufesi...",
    "loadingLunch": "Iyalayisha ithina...",
    "loadingDinner": "Iyalayisha isidlo sakusihlwa...",
    "cal": "cal",
    "protein": "iphosthini",
    "swapMeal": "Shintsha ukudla",
    "healthyOptionsNearYou": "Ukudla Okunempilo Eduze Nawe",
    "enableLocation": "Vula indawo",
    "view": "Buka",
    "discoverOptions": "Thola izindawo zokudla okunempilo, izitolo zokudla, nabathengisi bokudla okuhleliwe eduze nawe",
    "cuisinesSelected": "ukudla okukhethiwe",
    "cuisineSelected": "ukudla okukhethiwe",
    "dietaryPrefs": "izinto ozikhethile",
    "dietaryPref": "into oyikhethile",
    "customizeMeals": "Hlela ukudla kwakho",
    "subtitleAdaptive": "Ukuhlelwa kokudla okuvumelana namasiko nempilo yakho",
    "hideFavorites": "Fihla Izintandokazi",
    "viewFavorites": "Buka Izintandokazi",
    "customizeMealsLegacy": "Hlela ukudla kwakho ukuze kuhambisane namasiko akho nendlela odla ngayo",
    "viewFullPlan": "Buka Uhlelo Oluphelele",
    "exploreRecipes": "Hlola ama-Recipe"
  },
  "location": {
    "permissionTitle": "Thola ukudla okunempilo eduze nawe",
    "permissionDesc": "Kusetshenziselwa ukuphakamisa izindawo zokudla nezitolo ezihambisana nemigomo yakho yezempilo.",
    "howToEnable": "Indlela yokuvula:",
    "step1": "Chofoza isithombe senyaba 🔒 kubha yekheli yesiphequluli sakho",
    "step2": "Thola izimvume ze-\"Location\"",
    "step3": "Shintshela ku-\"Allow\"",
    "step4": "Vuselela (refresh) leli khasi",
    "refreshPage": "Vuselela Ikhasi",
    "allowLocation": "Vumela Indawo",
    "notNow": "Hhayi manje",
    "denied": "Ukufinyelela endaweni kuvaliwe. Ukuze ubone izinketho eziseduze, uzodinga ukuvula izimvume zendawo.",
    "unavailable": "Imininingwane yendawo ayitholakali okwamanje. Sicela uhlole izilungiselelo zedivayisi yakho.",
    "error": "Ayikwazi ukuthola indawo okuyo. Sicela uzame futhi noma uhlole izilungiselelo zesiphequluli.",
    "unsupported": "Isiphequluli sakho asikusekeli ukuthola indawo. Zama ukusebenzisa i-Chrome, Firefox, noma i-Safari.",
    "accessRequired": "Kudingeka Ukufinyelela Endaweni"
  },
  "womensHealth": {
    "title": "Impilo Yabesifazane",
    "description": "Landelela ukuya esikhathini, bhala izimpawu, futhi uthole amathiphu enhlalakahle",
    "cycleTracking": "Ukulandelela Isikhathi",
    "symptomLogging": "Ukubhala Izimpawu",
    "phaseInsights": "Ulwazi Ngesikhathi",
    "logPeriod": "Bhala Isikhathi",
    "logSymptoms": "Bhala Izimpawu",
    "insights": "Ulwazi",
    "tips": "Amathiphu Ezempilo",
    "overview": "Ukubuka kafushane",
    "history": "Umlando",
    "startTracking": "Qala Ukulandelela Isikhathi Sakho"
  },
  "profile": {
    "title": "Iphrofayili",
    "personalInfo": "Imininingwane Yakho",
    "healthProfile": "Iphrofayili Yezempilo",
    "preferences": "Okuthandayo",
    "language": "Ulimi",
    "selectLanguage": "Khetha Ulimi",
    "notifications": "Izaziso",
    "privacy": "Ubumfihlo",
    "security": "Ukuphepha",
    "quickAccess": "Ukufinyelela Ngokushesha",
    "editProfile": "Hlela Iphrofayili",
    "viewStats": "Buka Izibalo",
    "backToDashboard": "Buyela Ekhaya",
    "womensHealthTitle": "Impilo Yabesifazane",
    "womensHealthDesc": "Ukulandelela isikhathi, izimpawu namathiphu",
    "healthRemindersTitle": "Izikhumbuzi Zezeempilo",
    "healthRemindersDesc": "Phatha izaziso zakho",
    "manageRemindersDesc": "Hlela indlela ofuna ukukhunjuzwa ngayo nezaziso",
    "healthPatternAlerts": "Izixwayiso Zezempilo Yakho",
    "supportHelp": "Ukwesekwa Noshizo",
    "supportHelpDesc": "Thola usizo, bika izinkinga, noma ufunde imibuzo evamile",
    "admin": "Ukuphatha",
    "adminDesc": "Buka izibalo zokusetshenziswa",
    "giveFeedback": "Nikela Ngombono",
    "giveFeedbackDesc": "Xoxa nathi ngolwazi lwakho lwe-HealthLoop",
    "reportProblem": "Bika Inkinga",
    "reportProblemDesc": "Sisize silungise amaphutha futhi sithuthukise i-app",
    "manageHealthInfo": "Phatha imininingwane yakho yezempilo ukuze uthole iseluleko esifanele wena",
    "basicInformation": "Imininingwane Eyisisekelo",
    "fullName": "Igama Eliphelele",
    "email": "I-imeyili",
    "dateOfBirth": "Usuku Lokuzalwa",
    "gender": "Ubulili",
    "height": "Ubude (cm)",
    "weight": "Isisindo (kg)",
    "medicalConditions": "Izimo Zezempilo",
    "allergies": "Izinto ezingakuphathi kahle (Allergies)",
    "personalHealth": "Impilo Yakho",
    "addCondition": "Faka isimo sezempilo",
    "addAllergy": "Faka into engakuphathi kahle",
    "saveChanges": "Londoloza Izinguquko",
    "saving": "Iyalondoloza...",
    "privacyMessage": "Idatha yakho yezempilo ivikelekile ngaphansi kwemithetho yobumfihlo"
  },
  "settings": {
    "title": "Izilungiselelo",
    "general": "Okuvamile",
    "account": "I-akhawunti",
    "appearance": "Isimo sokubukeka",
    "languageSettings": "Izilungiselelo Zolimi",
    "changeLanguage": "Shintsha ulimi",
    "languageNote": "Isixhumi-buso sibuyekezwa ngaleso sikhathi lapho ukhetha ulimi olusha. Izilimi zase-Afrika nezisanda kufakwa zibhalwe ukuthi Starter — zihunyushwe ngomshini ukuze zifinyelele kude, kusalindwe ukubuyekezwa ngabakhulumi bomdabu.",
    "languageUpdated": "Ulimi lubuyekezwe ngempumelelo",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Ihunyushwe ngomshini — kusalindwe ukubuyekezwa ngomkhulumi womdabu.",
    "regions": {
      "global": "Umhlaba wonke",
      "european": "Izilimi zaseYurophu",
      "middleEastern": "Izilimi zaseMpumalanga Ephakathi",
      "asian": "Izilimi zase-Eshiya",
      "african": "Izilimi zase-Afrika"
    }
  },
  "search": {
    "triggerLabel": "Sesha ku-HealthLoop",
    "triggerHint": "Zama \"steps\", \"pharmacy\" noma \"pregnancy\"",
    "triggerAriaLabel": "Vula usesho jikelele",
    "placeholder": "Sesha izici, izinto zokulandela isimo, usizo…",
    "inputAriaLabel": "Sesha izici ze-HealthLoop",
    "modalAriaLabel": "Sesha ku-HealthLoop",
    "close": "Vala",
    "clear": "Sula",
    "clearAriaLabel": "Sula usesho",
    "recentSearches": "Okusandukuseshwa",
    "tryFor": "Zama ukuseshela lokhu",
    "findFeatures": "Thola noma yisiphi isici ngemizuzwana.",
    "searchAcross": "Sesha kuyo yonke i-",
    "and": "kanye ne-",
    "sections": {
      "home": "Ekhaya",
      "nutrition": "Ezomsoco",
      "family": "Umndeni",
      "services": "Izinsiza",
      "support": "Usizo",
      "profile": "Iphrofayili"
    },
    "noMatchesFor": "Akukho okutholakele kokuthi \"{{query}}\"",
    "trySimpler": "Zama igama elilula njengokuthi steps, nutrition noma specialist.",
    "comingSoonBadge": "Iyeza maduze",
    "escToClose": "ukuze uvale",
    "resultSingular": "{{count}} umphumela",
    "resultPlural": "{{count}} imiphumela",
    "searchAcrossApp": "Sesha kulo lonke uhlelo lokusebenza"
  },
  "familyMember": {
    "confirmRemove": "Ingabe uyafuna ukukhipha u-{{name}} ekulandeleni isimo sezempilo somndeni?",
    "removed": "U-{{name}} ukhishiwe emndenini",
    "removeFailed": "Kwehlulekile ukukhipha ilungu",
    "viewDetails": "Buka imininingwane",
    "edit": "Hlela",
    "remove": "Khipha",
    "yearsSuffix": "iminyaka",
    "healthGoalsLabel": "Imigomo yezeMpilo:",
    "moreSuffix": "okwengeziwe",
    "activeInsights": "Ulwazi Olusebenzayo",
    "viewAllInsights": "Buka lonke ulwazi olungu-{{count}} →",
    "viewFullProfile": "Buka Iphrofayili Yezempilo Egcwele",
    "lifeStage": {
      "infant": "Usane (0-2)",
      "toddler": "Ingane eqala ukuhamba (2-5)",
      "child": "Ingane (6-12)",
      "adolescent": "Ibhungu/Intombazane (13-17)",
      "adult": "Umuntu omdala (18-59)",
      "senior": "Osekhulile (60+)",
      "unknown": "Akwaziwa"
    }
  },
  "profileDeep": {
    "backToDashboard": "Buyela kudeshibhodi",
    "profileCompletion": "Ukuphothulwa kwephrofayili",
    "healthSummary": "Isifinyezo sezempilo",
    "sectionA": "Isiqephu A",
    "sectionB": "Isiqephu B",
    "sectionC": "Isiqephu C",
    "sectionD": "Isiqephu D",
    "personalDetails": "Imininingwane yakho",
    "healthInformation": "Ulwazi lwezempilo",
    "accountSettings": "Izilungiselelo ze-akhawunti",
    "fullName": "Igama eligcwele",
    "email": "I-imeyili",
    "dob": "Usuku lokuzalwa",
    "gender": "Ubulili",
    "genderPlaceholder": "isb., Owesifazane, Owesilisa",
    "height": "Ubude (cm)",
    "heightPlaceholder": "isb., 170",
    "weight": "Isisindo (kg)",
    "weightPlaceholder": "isb., 70",
    "allergies": "Okungezwani nakho (Allergies)",
    "allergiesPlaceholder": "isb., Amantongomane",
    "medicalConditions": "Isimo sempilo",
    "conditionsPlaceholder": "isb., Umfutho wegazi ophezulu",
    "medications": "Imithi oyisebenzisayo",
    "medicationsPlaceholder": "isb., Lisinopril 10mg, nsuku zonke",
    "emergencyContact": "Omthintayo ngezikhathi eziphuthumayo",
    "emergencyOptional": "(uma uthanda)",
    "emergencyPlaceholder": "isb., Umama +27-555-0100",
    "emergencyNote": "Lokhu kwabelwa abezempilo kuphela uma uvumile.",
    "saveChanges": "Gcina izinguquko",
    "saving": "Iyayigcina...",
    "editProfile": "Hlela iphrofayili",
    "cancelEditing": "Yeka ukuhlela",
    "healthScore": "Amaphuzu ezempilo",
    "streak": "Ukuqhubeka njalo",
    "streakDays": "{{n}} wezinsuku",
    "memberSince": "Ilungu kusukela",
    "remindersActive": "Izikhumbuzi ziyasebenza",
    "conditionsTracked": "Izimo ezilandelelwayo",
    "nextAgenda": "Okulandelayo ohlelweni lwakho",
    "notificationsReminders": "Izaziso nezikhumbuzi",
    "notificationsRemindersDesc": "Hlela izikhathi nezindlela zezikhumbuzi zezempilo",
    "emailNudges": "Izikhumbuzi ze-imeyili",
    "emailNudgesDesc": "Izikhumbuzi ezincane nemibiko yamasonto onke",
    "on": "Kuvuliwe",
    "paused": "Kumisiwe",
    "privacySecurity": "Ubumfihlo nokuvikeleka",
    "privacySecurityDesc": "Vuselela iphasiwedi yakho ukuze ugcine i-akhawunti yakho iphephile",
    "preferencesTitle": "Okuncanyelwayo",
    "preferencesDesc": "Ulimi, isifunda, nokwenza kulingane nawe",
    "supportHelp": "Uksizwa nosizo",
    "supportHelpDesc": "Thola izimpendulo bese usithinta",
    "giveFeedback": "Nikela ngombono",
    "giveFeedbackDesc": "Sitshele ukuthi yini okufanele siyithuthukise",
    "reportProblem": "Bika inkinga",
    "reportProblemDesc": "Uthole iphutha? Sazise",
    "adminInsights": "Ulwazi lokuphatha",
    "adminInsightsDesc": "Izibalo zokusetshenziswa",
    "adminBadge": "Umlawuli",
    "shareWithClinician": "Yabelana nabasebenzi bezempilo",
    "shareWithClinicianDesc": "Isifinyezo sokufundwa kuphela · siphela ngokwaso · singahoxiswa noma nini",
    "share": "Yabelana",
    "profileMayBeOutOfDate": "Iphrofayili ingaba isiphelelwe yisikhathi",
    "profileMayBeOutOfDateDesc": "Gcina imininingwane yakho yezempilo inembile ukuze uthole iseluleko esingcono — ngisho nezinguquko ezincane (isisindo, imithi) ziyasisiza.",
    "updateNow": "Buyekeza manje",
    "profileUpdateError": "Anikwazanga ukubuyekeza okukhethile. Sicela uzame futhi.",
    "healthLoopUser": "Umsebenzisi we-HealthLoop",
    "updatedLabel": "Kubuyekeziwe",
    "noEntries": "Akukho okufakiwe okwamanje.",
    "completionComplete": "Iphrofayili yakho iphelele. Sesingakunika iseluleko sethu esingcono kakhulu. 💚",
    "completionAlmostThere": "Usuzofika. Imininingwane embalwa eyengeziwe ivula ulwazi olunzulu.",
    "completionInProgress": "Gcwalisa iphrofayili yakho ukuze uvule ulwazi olungcono lwezempilo.",
    "justNow": "manje nje",
    "minAgo": "{{n}} umzuzu owedlule",
    "minsAgo": "{{n}} imizuzu eyedlule",
    "hourAgo": "{{n}} ihora elidlule",
    "hoursAgo": "{{n}} amahora adlule",
    "dayAgo": "{{n}} usuku owedlule",
    "daysAgo": "{{n}} izinsuku ezidlule",
    "checkinDueToday": "Ukuhlola kumele kwenziwe namuhla",
    "checkinDueTonight": "Ukuhlola kumele kwenziwe namuhla ebusuku"
  },
  "supportDeep": {
    "backToSettings": "Buyela kuzilungiselelo",
    "quickNavAria": "Izigaba zosizo",
    "searchPlaceholder": "Funa usizo...",
    "searchAria": "Funa imibuzo evame ukubuzwa",
    "resultsCount": "{{n}} umphumela",
    "resultsCountPlural": "{{n}} imiphumela",
    "questionsCount": "{{n}} imibuzo",
    "liveChatTitle": "Xoxa nathi manje",
    "liveChatDesc": "Khuluma nathi ngesikhathi sangempela · Msomb–Lwesih 9am–6pm",
    "startChat": "Qala Ingxoxo",
    "liveChatSoonToast": "Ukuxoxa bukhoma kuyeza maduze. Okwamanje, i-imeyili isebenza kahle.",
    "emailUsTitle": "Sibhulele i-imeyili",
    "emailUsDesc": "Impendulo phakathi kwamahora angama-24–48",
    "copy": "Kopisha",
    "emailCopied": "I-imeyili ikopishiwe.",
    "contactFormTitle": "Ifomu lokuxhumana",
    "contactFormDesc": "Sithumele umlayezo — sizophendula nge-imeyili.",
    "yourNameLabel": "Igama lakho *",
    "namePlaceholder": "Jane Doe",
    "yourEmailLabel": "I-imeyili yakho *",
    "emailPlaceholder": "jane@isibonelo.com",
    "subjectOptional": "Isihloko (uma uthanda)",
    "subjectPlaceholder": "Singakusiza ngani?",
    "messageLabel": "Umlayezo *",
    "messagePlaceholder": "Sitshele kancane ngalokho okudingayo.",
    "sending": "Iyayithumela...",
    "sendMessage": "Thumela Umlayezo",
    "messageSent": "Umlayezo uthunyelwe",
    "messageSentDesc": "Sizophendula phakathi kwamahora angama-24–48.",
    "callbackTitle": "Cela ukushayelwa",
    "callbackDesc": "Sizokufonela ngesikhathi esikuvumelele.",
    "phoneLabel": "Inombolo yocingo *",
    "phonePlaceholder": "+27 (555) 123-4567",
    "preferredTimeLabel": "Isikhathi osikhethayo (uma uthanda)",
    "preferredTimePlaceholder": "isb. kusasa ntambama",
    "reasonLabel": "Isizathu (uma uthanda)",
    "reasonPlaceholder": "Kafushane, yini ongathanda ukuyidingida?",
    "submitting": "Iyafakwa...",
    "requestCallback": "Cela ucingo",
    "callbackRequested": "Ucingo luceliwe",
    "callbackRequestedDesc": "Sizoxhumana nawe phakathi kwamahora angama-24.",
    "medicationSupport": "Usizo lwemithi",
    "medicationSupportDesc": "Landelela imithi oyiyalelwe, ukugcwaliswa kabusha, nezikhumbuzi.",
    "goToMedications": "Iya emithini →",
    "specialistConsultation": "Ukubonana nochwepheshe",
    "specialistConsultationDesc": "Xhumana nabasebenzi bezempilo ukuze uthole iseluleko sezempilo esenzelwe wena.",
    "connectExpert": "Xhumana nochwepheshe →",
    "videoConsult": "Ukubonana nge-Video",
    "videoConsultDesc": "Bhuka isikhathi sokukhuluma ubuso nobuso nochwepheshe nge-video.",
    "bookConsultation": "Bhuka ukubonana →",
    "premium": "Premium",
    "healthDisclaimer": "I-HealthLoop isekela impilo yakho yansuku zonke — ayithathi indawo yokunakekelwa kwezempilo okuphuthumayo. Uma kukhona okuzizwa kuphuthuma, sicela uthinte abezimo eziphuthumayo endaweni yakini.",
    "categoryLabel": "Isigaba",
    "catBug": "Iphutha / Bug",
    "catPerformance": "Ukuhamba kancane",
    "catFeature": "Into engasebenzi",
    "catUi": "Inkinga yokubonakala",
    "catOther": "Okunye",
    "issueTitle": "Isihloko senkinga *",
    "issueTitlePlaceholder": "Isifinyezo esifushane",
    "detailedDescription": "Incazelo enemininingwane *",
    "detailedDescriptionPlaceholder": "Kwenzekeni? Ubwenzani ngenkathi kwenzeka? Izinyathelo ozithathile ziyasisiza kakhulu.",
    "autoAttachNote": "Imininingwane yocingo ne-browser ifakwa ngokwayo.",
    "submitReport": "Thumela umbiko",
    "reportSubmitted": "Umbiko uthunyelwe",
    "reportSubmittedDesc": "Ithimba lethu seliyayibheka inkinga.",
    "fillAllFields": "Sicela ugcwalise zonke izindawo ezidingekayo",
    "problemReportSubmittedToast": "Umbiko wenkinga uthunyelwe. Sizophenya bese sibuyela kuwe maduze.",
    "messageSentToast": "Umlayezo uthunyelwe. Sizophendula phakathi kwamahora angama-24–48.",
    "callRequestedToast": "Isicelo socingo samukeliwe. Sizoxhumana nawe phakathi kwamahora angama-24.",
    "submitFailGeneric": "Kuhlulekile ukuthumela. Sicela uzame futhi noma ubhalele i-imeyili ku-{{email}}.",
    "submitFailContact": "Kuhlulekile ukuthumela. Sicela ubhalele i-imeyili ku-{{email}} ngqo.",
    "comingSoon": "Iyeza Maduze",
    "specialistRoadmapTitle": "Khuluma noChwepheshe",
    "specialistRoadmapSubtitle": "Usizo lwabantu luyaza. Lezi zindlela zizohlala lapha ukuze usizo luhlale luseduze.",
    "talkToSpecialistTitle": "Khuluma noChwepheshe",
    "talkToSpecialistDesc": "Xoxa ngesikhathi sangempela nabasebenzi bezempilo abanemvume ngemibuzo yezempilo yansuku zonke.",
    "bookSpecialistTitle": "Bhuka uChwepheshe",
    "bookSpecialistDesc": "Hlela isikhathi sokukhuluma u-1:1 nochwepheshe ofanele imigomo yakho.",
    "liveHealthGuidanceTitle": "Iseluleko Sezempilo Esibukhoma",
    "liveHealthGuidanceDesc": "Usizo lwe-video olusheshayo lwezimpawu zokugula, imiphumela yaselabhu, noma izinhlelo zokunakekelwa.",
    "mentalWellnessTitle": "Usizo Lwezempilo Yengqondo",
    "mentalWellnessDesc": "Usizo oluyimfihlo oluvela kochwepheshe bezempilo yengqondo lapho impilo inzima.",
    "wellnessNavigationTitle": "Ukuholwa Kwezempilo",
    "wellnessNavigationDesc": "Isiqondiso esikusiza ukuba ukhethe isinyathelo esifanele okulandelayo.",
    "pharmacyRoadmapTitle": "Usizo Lwemithi Nekhemisi",
    "pharmacyRoadmapSubtitle": "Usizo lwekhemisi luhlala ngaphakathi kwe Support & Help.",
    "medicationGuidanceTitle": "Iseluleko Ngemithi",
    "medicationGuidanceDesc": "Iseluleko ngolimi olulula mayelana nemithamo, isikhathi, nokusebenzisana kwemithi.",
    "findNearbyPharmacyTitle": "Thola Ikhemisi Eliseduze",
    "findNearbyPharmacyDesc": "Thola ngokushesha amakhemisi athembekile endaweni yakini lapho udinga ukugcwalisa imithi.",
    "refillReminderTitle": "Usizo Lwesikhumbuzi Semithi",
    "refillReminderDesc": "Izikhumbuzi ezincane ukuze ungaphumilelwa yimithi ebalulekile.",
    "otcWellnessTitle": "Iseluleko Semithi etholakala ngaphandle kwencwadi kadokotela (OTC)",
    "otcWellnessDesc": "Iseluleko esikhethiwe ngezinketho eziphephile nezisekelwe ubufakazi."
  },
  "careServices": {
    "pageTitle": "Izinsiza Zenakekelo",
    "pageSubtitle": "Usizo lwezempilo olwakhelwe uhambo lwakho lwansuku zonke.",
    "specialistCareTitle": "Ukunakekelwa Kochwepheshe",
    "specialistCareSubtitle": "Khuluma nabasebenzi bezempilo futhi ubhuke ochwepheshe ofanele lapho umdinga.",
    "medicationPharmacyTitle": "Imithi Nekhemisi",
    "medicationPharmacySubtitle": "Iseluleko ngemithi ngolimi olulula nosizo lwekhemisi.",
    "wellnessSupportTitle": "Usizo Lwezempilo",
    "wellnessSupportSubtitle": "Impilo yengqondo, iseluleko semithi ye-OTC, nendlela ecacile yesinyathelo esilandelayo.",
    "futureWellnessTitle": "Izici Wezempilo Zakusasa",
    "futureWellnessSubtitle": "Ukubuka kafushane lokho okuzayo kumephu ye-HealthLoop yezempilo yokuzivikela.",
    "futureFeatureBadge": "Isici Sakusasa",
    "futurePersonalizedMealsTitle": "Izinhlelo Zeudla Ezikhethekile",
    "futurePersonalizedMealsDesc": "Izinhlelo zokudla ezihambisana nemigomo yakho, okungezwani nakho, namasiko akho.",
    "futureHealthyDeliveryTitle": "Ukulethwa Kokudla Okunempilo",
    "futureHealthyDeliveryDesc": "Ukudla okukhethiwe okuvela emakhishini anakekela ezempilo.",
    "futureFarmFreshTitle": "Ukudla Okusha Kwasepulazini",
    "futureFarmFreshDesc": "Ukuthola ukudla okulinywe endaweni yakini nokuvela kubalingani basemapulazini.",
    "futureFoodPartnershipsTitle": "Ukubambisana Ngokudla Kwezempilo",
    "futureFoodPartnershipsDesc": "Ubudlelwano obukhethiwe namakhishi anempilo nezitolo zokudla.",
    "futureNutritionCoachingTitle": "Ukuqeqeshwa Ngezomsoco",
    "futureNutritionCoachingDesc": "Isiqondiso somuntu nomuntu esivela kubaqeqeshi bezomsoco abaqeqeshiwe.",
    "futureFamilyWellnessTitle": "Izinhlelo Zezempilo Zomndeni",
    "futureFamilyWellnessDesc": "Izinhlelo ezabiwe ezigcina wonke umndeni usendleleni efanele.",
    "futureWellnessPlusTitle": "Ubulungu be-Wellness+",
    "futureWellnessPlusDesc": "Izinga eliphakeme lesiqondiso esikhethekile nosizo olubalulekile.",
    "futurePharmacyPartnersTitle": "Ukubambisana Namakhemisi",
    "futurePharmacyPartnersDesc": "Ukuxhumana namakhemisi athembekile ngeseluleko nemithi.",
    "futureAdvancedSpecialistTitle": "Ukunakekelwa Kochwepheshe Okuthuthukile",
    "futureAdvancedSpecialistDesc": "Ukuthola ochwepheshe, imibono yesibili, nokuholwa ekunakekelweni.",
    "futureWellnessMarketplaceTitle": "Indawo Yokuthenga Yezempilo",
    "futureWellnessMarketplaceDesc": "Indawo ekhethiwe yemikhiqizo nezinsiza zezempilo ezihloliwe.",
    "futureVendorCollabTitle": "Izinhlelo Zokubambisana Nabathengisi",
    "futureVendorCollabDesc": "Izinhlelo zekhwalithi zabalingani bokudla okunempilo nabezempilo."
  },
  "dashboardDeep": {
    "healthProfile": "Iphrofayili Yezempilo",
    "notifications": "Izaziso",
    "familyAccounts": "Ama-akhawunti Omndeni",
    "settings": "Izilungiselelo",
    "logout": "Phuma",
    "allCaughtUp": "Uqedile konke okwamanje.",
    "weekInReview": "Ukubuyekezwa kwesonto lakho",
    "dismissNotification": "Susa isaziso",
    "dismissWeeklyDigest": "Susa umbiko weviki",
    "notificationsAria": "Izaziso",
    "profileMenuAria": "Vula imenyu yephrofayili",
    "loadingWellness": "Ilayisha isifinyezo sakho sezempilo",
    "nextTip": "Iseluleko esilandelayo",
    "todayAtGlance": "Ukubuka kwanamuhla",
    "healthScoreLabel": "Amaphuzu Ezempilo",
    "currentStreakLabel": "Ukuqhubeka Kwamanje",
    "todaysProgress": "Inqubekelaphambili Yanamuhla",
    "insightForYou": "Ulwazi lwakho",
    "checkMyHealthRisk": "Bheka ubungozi bami bezempilo",
    "quickAccess": "Ukungena Ngokushesha",
    "exploreCareServicesTitle": "Hlola Izinsiza Zenakekelo",
    "exploreCareServicesSubtitle": "Ukunakekelwa kochwepheshe · ikhemisi · ezempilo — konke endaweni eyodwa.",
    "familyCare": "Ukunakekelwa Komndeni",
    "healthLibrary": "Ulayibrari Wezempilo",
    "myHealthData": "Idatha Yami Yezempilo",
    "askQuestion": "Buza Umbuzo",
    "dashLoadError": "Anikwazanga ukulayisha ideshibhodi yakho. Sicela uzame futhi.",
    "taskUpdateError": "Anikwazanga ukubuyekeza umsebenzi. Sicela uzame futhi.",
    "perfectDay": "Usuku oluhle kakhulu! 🎉 Ukuqhubeka kwakho kwengeziwe.",
    "letsStart": "Ake siqale",
    "yourNextStepToday": "Isinyathelo sakho esilandelayo namuhla",
    "completeDailyCheck": "Gcwalisa ukuhlola kwakho kwezempilo kwansuku zonke",
    "startDailyCheck": "Qala Ukuhlola Kwansuku Zonke",
    "viewAll": "Buka konke",
    "graceProtected": "I-Grace ivikelekile",
    "todaysHealthRecommendations": "Izincomo Zezempilo Zanamuhla",
    "updateViaCheck": "Buyekeza ngokuhlola kwansuku zonke",
    "healthInsight": "Ulwazi Lwezempilo",
    "riskCheckSubtext": "Thola ulwazi lwezempilo olwenziwe wena ngemizuzwana",
    "foodDiet": "Ukudla Nokudla okunomsoco",
    "healthScoreNew": "Amaphuzu Ezempilo · Okusha",
    "letsBuildScore": "Ake sakhe amaphuzu akho ezempilo ndawonye",
    "oneHealthyHabitAtATime": "Umkhuba owodwa omuhle ngesikhathi.",
    "nextCheck": "Ukuhlola okulandelayo:",
    "todayAt8pm": "namuhla ngo-8:00 PM",
    "wellnessTipForYou": "Iseluleko Sezempilo Sanamuhla · Sakho",
    "wellnessTipForFactor": "Iseluleko Sezempilo Sanamuhla · Soku-{{factor}}",
    "logged": "Kurekhodiwe",
    "gotIt": "Ngizwile 👍",
    "gladToSeeYou": "Siyajabula ukukubona namuhla 💚",
    "takesLessThan60Sec": "Kuthatha isikhathi esingaphansi kwemizuzwana engama-60",
    "scoreReadyWhenYou": "Kulungile uma nawe usulungele",
    "scoreCompleteFirstCheck": "Gcwalisa ukuhlola kwakho kokuqala kwezempilo ukuze uvule ulwazi oluhambisana nawe.",
    "scoreExcellent": "Kuhle kakhulu",
    "scoreSupportExcellent": "Usesimweni esihle kakhulu namuhla. Qhubeka njalo.",
    "scoreGood": "Kuhle",
    "scoreSupportGood": "Wenza kahle. Gcina imikhuba yakho emihle.",
    "scoreModerate": "Kulingene",
    "scoreSupportModerate": "Wenza kahle, kodwa kunezindawo ezimbalwa ezidinga ukunakwa.",
    "scoreNeedsAttention": "Dinga Ukunakwa",
    "scoreSupportNeedsAttention": "Impilo yakho idinga ukunakwa namuhla. Izinguquko ezincane zingasiza."
  },
  "emailVerify": {
    "bannerWithEmail": "Sicela uqinisekise i-imeyili yakho ({{email}}) ukuze sigcine i-akhawunti yakho iphephile futhi sikulethele izikhumbuzi zakho.",
    "bannerNoEmail": "Sicela uqinisekise i-imeyili yakho ukuze sigcine i-akhawunti yakho iphephile futhi sikulethele izikhumbuzi zakho.",
    "sending": "Iyayithumela...",
    "resend": "Thumela i-imeyili futhi",
    "sentToast": "I-imeyili yokuqinisekisa ithunyelwe. Sicela ubheke i-inbox yakho.",
    "sendFailToast": "Anikwazanga ukuthumela i-imeyili yokuqinisekisa. Zame futhi emva kwesikhathi."
  },
  "forgotPassword": {
    "title": "Ukhohlwe Iphasiwedi?",
    "subtitle": "Ungakhathazeki! Faka i-imeyili yakho bese sikuthumelela imiyalelo yokuyisetha kabusha.",
    "emailLabel": "Ikheli le-I-imeyili",
    "emailPlaceholder": "i-imeyili.yakho@isibonelo.com",
    "sendResetLink": "Thumela Isixhumanisi Sokubuyisela",
    "sending": "Iyayithumela...",
    "backToLogin": "Buyela ekungeneni",
    "resendLink": "Thumela i-imeyili futhi",
    "successTitle": "Bheka I-imeyili Yakho",
    "successBody": "Uma i-akhawunti ikhona ye-{{email}}, sithumele isixhumanisi sokusetha kabusha iphasiwedi.",
    "linkExpires": "Isixhumanisi sizophelelwa yisikhathi emizuzwini engama-30.",
    "successToast": "Bheka i-imeyili yakho ukuze uthole imiyalelo",
    "errEmptyEmail": "Sicela ufake ikheli lakho le-imeyili",
    "errInvalidEmail": "Sicela ufake i-imeyili evumelekile",
    "errNetwork": "Anikwazanga ukuxhumana ne-server. Bheka i-internet yakho.",
    "errGeneric": "Anikwazanga ukuthumela i-imeyili. Sicela uzame futhi noma uthinte usizo."
  },
  "resetPassword": {
    "title": "Setha Iphasiwedi Entsha",
    "subtitle": "Dala iphasiwedi enamandla ye-akhawunti yakho",
    "newPasswordLabel": "Iphasiwedi Entsha",
    "newPasswordPlaceholder": "Faka iphasiwedi entsha",
    "confirmPasswordLabel": "Qinisekisa Iphasiwedi",
    "confirmPasswordPlaceholder": "Qinisekisa iphasiwedi entsha",
    "requirementsHint": "Kumele okungenani ibe nezinhlamvu eziyi-8 ezino-uppercase, lowercase, nenombolo",
    "resetPassword": "Setha Kabusha Iphasiwedi",
    "resetting": "Iyayisetha kabusha...",
    "successTitle": "Iphasiwedi Isethwe Kabusha Ngempumelelo!",
    "successBody": "Manje usungangena ngephasiwedi yakho entsha.",
    "successToast": "Iphasiwedi isethwe kabusha ngempumelelo!",
    "goToLogin": "Iya ekungeneni",
    "invalidLinkTitle": "Isixhumanisi Esingavumelekile",
    "invalidLinkBody": "Lesi sixhumanisi sokusetha kabusha iphasiwedi asivumelekile noma siphelelwe yisikhathi.",
    "requestNewLink": "Cela Isixhumanisi Esisha",
    "showPassword": "Khombisa iphasiwedi",
    "hidePassword": "Fihla iphasiwedi",
    "errInvalidLink": "Isixhumanisi esingavumelekile",
    "errMismatch": "Amaphasiwedi awafani",
    "errTooShort": "Iphasiwedi kumele ibe nezinhlamvu okungenani eziyi-8",
    "errExpiredToken": "Lesi sixhumanisi siphelelwe yisikhathi. Sicela ucele esisha.",
    "errNetwork": "Anikwazanga ukuxhumana ne-server. Bheka i-internet yakho.",
    "errGeneric": "Kuhlulekile ukusetha kabusha iphasiwedi. Sicela uzame futhi."
  },
  "tips": {
    "water1": "Ukuphuza amanzi emizuzwini engama-30 uvukile kungasiza emzimbeni nasemandleni.",
    "water2": "Ingilazi yamanzi ngaphambi kokudla ngakunye iyindlela elula yokunqanda ukoma.",
    "water3": "Ukufaka ulamula noma amancane ama-mint leaves kungenza amanzi anambitheke kamnandi.",
    "meals1": "Ukwengeza imifino eyodwa ngosuku kusekela impilo yamathumbu nenhliziyo.",
    "meals2": "Amantongomane noma imbewu ekudleni kwasekuseni kugcina amandla akho ezinzile.",
    "meals3": "Isithelo sonke singcono kunesiphuzo — i-fibre igcina ushukela wegazi ulingene.",
    "steps1": "Ukuhamba imizuzu eyi-10 emva kokudla kusiza umzimba wakho ukuba usebenze ushukela kahle.",
    "steps2": "Ukunwebeka (stretch) imizuzu emi-5 ekuseni kungehlisa ukukhathala futhi kukwenze uzole.",
    "steps3": "Ukusebenzisa izitebhisi ngisho kanye ngosuku kwakha amandla enhliziyo kancane kancane.",
    "sleep1": "Ukucisha izibani ihora ngaphambi kokulala kusiza umzimba ukuba uzilungiselele ubuthongo.",
    "sleep2": "Ukuvuka ngesikhathi esifanayo — ngisho nangezimpelasonto — kusiza umjikelezo wokulala.",
    "sleep3": "Imizuzu eyi-10 yokukhanya kwelanga ekuseni kusiza ukulawula isikhathi sokulala ngokwemvelo.",
    "general1": "Imizuzu emibili yokuphefumula kancane kungehlisa ukucindezeleka futhi kukusize ugxile.",
    "general2": "Phawula into eyodwa oyibongayo namuhla — ukunqoba kwengqondo okuncane kuyakhula.",
    "general3": "Ufikile namuhla. Lowo ngumkhuba owenza yonke eminye imikhuba ibe lula."
  },
  "factors": {
    "hydration": "ukuphuza amanzi",
    "nutrition": "umsoco",
    "movement": "ukuzivocavoca",
    "sleep": "ukulala"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Kuhluleke ukulayisha izinhlobo zokudla",
    "prefsSaved": "Izinketho zokudla zigciniwe! Sibuyekeza ukudla...",
    "prefsSaveFail": "Kuhluleke ukugcina izinketho zakho",
    "newOptionsFail": "Kuhluleke ukulayisha izinketho ezintsha",
    "invalidZip": "Sicela ufake i-zip code enemidijithi engu-5 evumelekile",
    "noVendorsArea": "Abekho abadayisi kule ndawo okwamanje. Sisakhulisa inethiwekhi yethu!",
    "vendorsFetchFail": "Kuhluleke ukuthola abadayisi",
    "selectVendorFirst": "Sicela uqale ukhethe umdayisi wokulethwa kokudla",
    "removedFromCart": "Susiwe enqoleni",
    "orderPlaced": "I-oda lifakwe ngempumelelo! 🎉",
    "enterZipFirst": "Sicela uqale ufake i-zip code yakho esigabeni sokulethwa kokudla",
    "mealNotAvailable": "Lokhu kudla akukatholakali ukuthi kulethwe endaweni yakini",
    "mealUnavailable": "Lokhu kudla akutholakali okwamanje kubadayisi abaseduze",
    "vendorOptionsFail": "Kuhluleke ukulayisha izinketho zomdayisi",
    "favoriteSaveFail": "Kuhluleke ukugcina okuthandwayo",
    "removedFromFavorites": "Susiwe kokuthandwayo",
    "favoriteRemoveFail": "Kuhluleke ukususa okuthandwayo",
    "cartEmpty": "Inqola yakho ingenalutho",
    "noMealOptions": "Azikho izinketho zokudla ezitholakalayo",
    "loadingOptions": "Kulayishwa izinketho zokudla...",
    "selectPreferences": "Khetha Izinketho Zakho Zokudla",
    "mealBuilder": "Umakhi weSidlo",
    "myFavorites": "Izinto Ezintandokazi",
    "myFavoriteMeals": "Izidlo Ezintandokazi",
    "noFavoritesYet": "Azikho izidlo ezintandokazi okwamanje!",
    "price": "Inani",
    "delivery": "Ukulethwa",
    "deliveryFee": "Imali yokulethwa",
    "distance": "Ibanga",
    "subtotal": "Inani elingaphansi",
    "total": "Inani selilonke",
    "orderNumber": "Inombolo ye-Oda",
    "vendor": "Umdayisi",
    "totalAmount": "Isamba semali",
    "estimatedDelivery": "Isikhathi sokufika esilinganiselwayo",
    "whyThisMeal": "Kungani loku kudla kufanelekile",
    "selectThisMeal": "Khetha Lolu Kudla",
    "swapMeal": "Shintsha Isidlo",
    "orderThisMeal": "Oda Lolu Kudla",
    "notAvailableNearYou": "Akutholakali eduze nawe",
    "tryAdjustingPrefs": "Zama ukushintsha izinketho zakho zokudla ukuze ubone iziphakamiso",
    "myMealPlanSummary": "Isifinyezo soHlelo lwami lokuDla",
    "saveCompletePlan": "Gcina uHlelo Lonke",
    "yourFoodPreferences": "Izinketho Zakho Zokudla",
    "editPreferences": "Hlela Izinketho",
    "healthyMealDelivery": "Ukulethwa Kokudla Okunempilo",
    "enableDelivery": "Vula Ukulethwa",
    "enterZipCode": "Faka i-Postcode / ZIP ukuze ubone ukudla okutholakalayo",
    "enterPostcode": "Faka i-Postcode / ZIP Code",
    "postcodePlaceholder": "isib., 4001 noma 2001",
    "postcodePartialHint": "Sicela ufake i-postcode yakho ephelele ukuze uthole imiphumela enembe kakhudlwana.",
    "noLocalPartnersFallback": "Abekho ozakwethu basendaweni abatholakele okwamanje. Sibonisa iziphakamiso zezithako zokudla zasendaweni esikhundleni salokho.",
    "noLivePartnersFallback": "Abekho ozakwethu bokudla be-HealthLoop abakhona endaweni yakini okwamanje.",
    "culturalNutritionTitle": "Ukuthola Okunempilo eKhaya",
    "culturalNutritionSubtitle": "Isiqondiso sempilo yomuntu siqu — esihambisana namasiko, imininingwane, nesilungiselwe indawo yakini.",
    "viewIngredientGuidance": "Buka Isiqondiso",
    "popularWellnessTitle": "Ukudla Kwasendaweni Okunempilo Okudumile",
    "popularWellnessIntro": "Izithako zokudla ezihambisana namasiko nezinhlobo zezindawo zokudla okunempilo abantu abajwayele ukuzisebenzisa endaweni yakini.",
    "subsectionPopularFoodsTitle": "Ukudla Kwemihla Ngemihla Kwempilo",
    "subsectionCulturalIngredientsTitle": "Iziphakamiso Zezithako Zamasiko",
    "subsectionHealthySwapsTitle": "Imibono Yokushintsha Ukudla Okunempilo",
    "subsectionLocalEnvironmentTitle": "Indawo Yempilo Yasendaweni",
    "subsectionLocalEnvironmentIntro": "Izindawo lapho abantu endaweni yakini bethola khona ukudla okunempilo okuhambisana namasiko.",
    "findLocalTitle": "Izinketho Zasendaweni Ezinhle",
    "findLocalSubtitle": "Thola abadayisi abaseduze, izitolo, nezithako zokudla okuhambisana namasiko endaweni yakini.",
    "findOptions": "Thola Izinketho",
    "searching": "Iyayifuna...",
    "nearbyVendorsFound": "Kutholwe izinketho zempilo ezi-{{count}} eduze nawe",
    "orderHintEnabled": "Thinta u-\"Oda Lolu Kudla\" kunoma yiliphi ikhadi lokudla ngezansi ukuze ubone amanani omdayisi.",
    "orderHintDisabled": "Vula i-\"Vula Ukulethwa\" ngenhla ukuze ode noma yikuphi kwalokhu kudla ngqo ngamakhadi.",
    "localIngredientTitle": "Ukutholakala Kwezithako Zasendaweni",
    "localIngredientIntro": "Ukudla okubalulekile okuhambisana namasiko nokuthi ungakutholaphi endaweni yakini.",
    "lookFor": "Bheka lokhu",
    "noVendorsFallback": "Abekho abadayisi bokuletha abaqinisekisiwe lapha okwamanje — isiqondiso sezithako ngenhla sisebenza kunoma iyiphi igrosa yendawo noma emakethe yabalimi.",
    "showingMealsFrom": "Kuboniswa izidlo ezivela ku-",
    "sectionSnapshot": "Isifinyezo Somsoco Sansuku Zonke",
    "sectionSnapshotSubtitle": "Ukubuka ngokushesha ukuphuza amanzi, amakhalori, nokulinganisela kokudla kwanamuhla.",
    "snapshotHydration": "Ukuphuza Amanzi",
    "snapshotHydrationHint": "Zama ukuphuza izingilazi ezingu-6 kuya kwezingu-8 namuhla.",
    "snapshotCalories": "Amakhalori",
    "snapshotCaloriesHint": "Ukulandelela kuyeza maduze.",
    "snapshotBalance": "Ukulinganisela Kokudla",
    "mealsLogged": "izidlo ezikhethiwe",
    "snapshotTip": "Iseluleko Sempilo",
    "snapshotTipHint": "Faka imifino eyodwa eyengeziwe esidlweni sakho esilandelayo.",
    "sectionRecommendations": "Iziphakamiso Ezihlakaniphile",
    "sectionRecommendationsSubtitle": "Isiqondiso sezithako ezihambisana namasiko nemibono yokushintsha ukudla kube okunempilo.",
    "sectionGoals": "Imigomo Yomsoco",
    "sectionGoalsSubtitle": "Landelela imiphumela ebalulekile kuwe.",
    "goalWeight": "Ukunakekela Isisindo",
    "goalWeightDesc": "Izidlo ezilungiselwe isisindo esikahle nesiqhubekayo.",
    "goalEnergy": "Ukuqinisa Amandla",
    "goalEnergyDesc": "Amandla aqhubekayo ezinsukwini ezinde nezithela izithelo.",
    "goalImmunity": "Ukuvikela Umzimba",
    "goalImmunityDesc": "Ukukhetha ukudla okunama-antioxidant amaningi ukuze uhlale uqinile.",
    "goalFamily": "Umsoco Womndeni",
    "goalFamilyDesc": "Kufaka phakathi ukudla kwezingane nomama abakhulelwe.",
    "sectionGuidance": "Isiqondiso Sedlo",
    "sectionGuidanceSubtitle": "Imibono yebhulakufasi, isidlo sasemini, isidlo sakusihlwa, ne-snack ongakushintsha ngokukhululeka.",
    "futureNutritionTitle": "Ukusekelwa Komsoco Kwesikhathi Ezayo",
    "futureNutritionBody": "Umsoco wempilo oqondiswe kuwe, ukubambisana kokudla okunempilo, nokunakekelwa kokudla komndeni kuyeza ku-HealthLoop ekubuyekezweni kwesikhathi esizayo.",
    "comingSoon": "Kuyeza Maduze",
    "coverageLocalStores": "Izitolo zasendaweni ezinempilo",
    "coverageLocalFarms": "Amapulazi asendaweni",
    "coverageCertifiedVendors": "Abadayisi abaqinisekisiwe",
    "coverageFreshProduce": "Imifino nezithelo ezintsha",
    "medWellnessFutureTitle": "Ukunakekelwa Kwemithi Nempilo",
    "medWellnessFutureDesc": "Kuhlanganisa uhlelo lwakho lomsoco nesiqondiso esinaka imithi yakho. Lokhu kutholakala ngaphansi kuka-Support & Help.",
    "pharmacyAssistFutureTitle": "Usizo Lwasephamasi",
    "pharmacyAssistFutureDesc": "Thola amaphamasi aseduze nezikhumbuzi zemithi kanye nezidlo zakho. Lokhu kutholakala ngaphansi kuka-Support & Help.",
    "savePreferences": "Gcina Izinketho",
    "quickAccessSavedMeals": "Ukuthola kalula izidlo zakho ozigcinile",
    "saveMealsFromBuilder": "Gcina izidlo kusukela kuthebhu kaMakhi weSidlo",
    "chooseVendor": "Khetha umdayisi ozooda kuye lolu kudla",
    "yourCart": "Inqola Yakho",
    "addMealsToStart": "Faka izidlo ezinkethweni ezingezansi ukuze uqale",
    "orderPlacedDesc": "I-oda lakho lokudla okunempilo lifakwe ngempumelelo",
    "continueShopping": "Qhubeka Nokuthenga",
    "trackOrder": "Landelela I-oda",
    "healthyStoresTitle": "Izitolo Ezidayisa Ukudla Okunempilo Nezindawo Zenhlalakahle Eziseduze",
    "healthyStoresIntro": "Izinhlobo zezitolo ezihambisana namasiko ongazibheka endaweni yakini — ukunika umqondo nje, hhayi ukulethwa kokudla.",
    "healthyStoresGuidanceTitle": "Isiqondiso sokuthenga okunempilo",
    "healthyStoresDisclaimer": "I-HealthLoop yabelana ngogqozi lwenhlalakahle jikelele nokuthenga okunempilo kuphela — hhayi iseluleko sokwelashwa noma sokudla okunqunyiwe.",
    "healthyStores": {
      "organic": {
        "type": "Izitolo zokudla okuphilayo (Organic)",
        "description": "Imikhiqizo emisha, engenazibulala-zinambuzane kanye nokudla okuyisisekelo okungakashintshwa kakhulu.",
        "tags": [
          "Ukudla kwemvelo",
          "Imikhiqizo emisha"
        ]
      },
      "farmers": {
        "type": "Izimakethe zabafuyi/abalimi",
        "description": "Izithelo nemifino yasendaweni yesizini, kanye nemikhiqizo yamasiko eqondene ngqo nabalimi.",
        "tags": [
          "Okwasekhaya",
          "Okwesizini"
        ]
      },
      "african": {
        "type": "Izitolo zemifino nemikhiqizo yase-Afrika",
        "description": "Obhanyana, amaplantain, imifino yamaqabunga, amantongomane esundu kanye nokudla okuyisisekelo kwaseNtshonalanga naseMpumalanga Afrika.",
        "tags": [
          "Okwamasiko",
          "Imikhiqizo emisha"
        ]
      },
      "caribbean": {
        "type": "Izimakethe zokudla kwemvelo zaseCaribbean",
        "description": "I-Callaloo, umdumbula, u-scotch bonnet, i-ackee, i-breadfruit nokudla okuyisisekelo kwaseziqhingini.",
        "tags": [
          "Okwamasiko",
          "Ukudla kwemvelo"
        ]
      },
      "asian": {
        "type": "Izitolo ezinkulu zemifino zase-Eshiya",
        "description": "I-Bok choy, i-daikon, i-lotus root, i-tofu, amakhambi amasha nokudla okuyisisekelo kwase-Eshiya.",
        "tags": [
          "Okwamasiko",
          "Imikhiqizo emisha"
        ]
      },
      "halal": {
        "type": "Izimakethe zokudla okunempilo ze-Halal",
        "description": "Amaprotheni aqinisekiswe njenge-Halal, imikhiqizo emisha nezinongo zamasiko.",
        "tags": [
          "Halal",
          "Okwamasiko"
        ]
      },
      "mediterranean": {
        "type": "Izimakethe zokudla kwemvelo zase-Mediterranean",
        "description": "Amafutha omnqumo, udali, amakhambi amasha, okusanhlamvu nokudla okuyisisekelo kwase-Mediterranean.",
        "tags": [
          "Okwamasiko",
          "Ukudla kwemvelo"
        ]
      },
      "wellness": {
        "type": "Izitolo zokudla ezigxile enhlalakahleni",
        "description": "Ukudla kwemvelo okukhethiwe, ukudla okusekelwe ezitshalweni nezinto zasikhululwane ezihlanzekile.",
        "tags": [
          "Ukudla kwemvelo",
          "Okusekelwe ezitshalweni"
        ]
      }
    },
    "healthyShoppingTips": [
      "Thenga emaphethelweni esitolo kuqala — imikhiqizo emisha, amaprotheni nalawo athatha indawo yobisi kuvame ukuba ngasemaphethelweni.",
      "Khetha ukudla kwemvelo, okunesithako esisodwa kunesitolo esicutshungulwe kakhulu.",
      "Khetha imikhiqizo yasendaweni yesizini — ivame ukuba misha, ithengeke kalula futhi ibe nempilo kakhulu.",
      "Buza abadayisi ngomsuka nendlela yokukhulisa ukudla — abaningi bazokutshela ngenjabulo."
    ]
  },
  "messages": {
    "success": "Impumelelo!",
    "error": "Iphutha",
    "saved": "Kugcinwe ngempumelelo",
    "updated": "Kubuyekezwe ngempumelelo",
    "deleted": "Susiwe ngempumelelo",
    "confirmDelete": "Uqinisekile ukuthi ufuna ukususa lokhu?",
    "networkError": "Iphutha lenethiwekhi. Sicela uzame futhi.",
    "somethingWrong": "Kukhona okungahambanga kahle",
    "failedToLoad": "Kuhluleke ukulayisha ideshibhodi",
    "offlineMode": "Awukho ku-inthanethi - kuboniswa idatha elinganiselwe",
    "locationDenied": "Imvume yendawo inqatshiwe. Hlola izilungiselelo zesiphequluli ukuze uyivumele.",
    "locationUnavailable": "Imininingwane yendawo ayitholakali",
    "locationTimeout": "Isicelo sendawo siphelelwe isikhathi. Sicela uzame futhi.",
    "locationError": "Ayikwazi ukufika endaweni okuyo",
    "locationGranted": "Imvume yendawo inikeziwe! Kuboniswa izinketho eziseduze",
    "locationNotSupported": "Izinkonzo zendawo azisekelwa isiphequluli sakho",
    "requestingLocation": "Kucelwa imvume yendawo..."
  },
  "trust": {
    "medicalDisclaimer": "Ukuzihlangula kwezoLwazi lwezeMpilo",
    "privacySecure": "Idatha yakho iyimfihlo futhi ivikelekile",
    "dataEncrypted": "Yonke idatha ifihliwe (encrypted) futhi iyimfihlo",
    "notMedicalAdvice": "Akusona iseluleko sezokwelapha",
    "consultProvider": "Ngaso sonke isikhathi thintana nabasebenzi bezempilo",
    "evidenceBased": "Isiqondiso esisekelwe ebufakazini besayensi",
    "generalEducation": "Imfundo yezempilo jikelele",
    "preventiveGuidance": "Isiqondiso sokuvikela izifo",
    "lifestyleSupport": "Ukuze uqaphele futhi usekelwe endleleni yokuphila",
    "lastUpdated": "Kubuyekezwe ekugcineni",
    "expertReviewed": "Kubuyekezwe ongoti",
    "aiGenerated": "Ulwazi olukhiqizwe yi-AI",
    "disclaimerShort": "I-HealthLoop inikeza imfundo yezempilo futhi ayithathi indawo yeseluleko sochwepheshe bezempilo.",
    "disclaimerFull": "I-HealthLoop isekela impilo evikelayo nokuqwashisa kusenesikhathi. Sinikeza imfundo yezempilo, ukulandelela imikhuba, nokuqonda ngezempilo. Lokhu akuthathi indawo yokunakekelwa kwezokwelapha okunikezwa ochwepheshe. Ngaso sonke isikhathi thintana nabasebenzi bezempilo abaqeqeshiwe ukuze uthole iseluleko somtholampilo, ukuhlolwa kwezifo, noma ukwelashwa.",
    "trustBanner": {
      "title": "I-HealthLoop ikhona ukuze isekele uhambo lwakho lwezempilo",
      "description": "Sinikeza imfundo yezempilo jikelele nesiqondiso sokuvikela izifo ngokusekelwe emithonjeni ethembekile. Lokhu akuthathi indawo yeseluleko sochwepheshe bezempilo. Ngaso sonke isikhathi thintana nabasebenzi bezempilo abaqeqeshiwe lapho wenza izinqumo zezempilo."
    }
  },
  "health": {
    "preventiveHealth": "Isilandeleli Sezempilo Esivikelayo",
    "educationHub": "Isizinda Semfundo",
    "engagementWidget": "Ithuluzi Lokuzibandakanya",
    "wellnessCheckIn": "Ukuzihlola Kwempilo",
    "todaysMetrics": "Izilinganiso Zanamuhla",
    "bloodPressure": "Umfutho Wegazi",
    "heartRate": "Isigqi Senhliziyo",
    "weight": "Isisindo",
    "sleep": "Ukulala",
    "waterIntake": "Ukuphuza Amanzi",
    "exercise": "Ukuzivocavoca",
    "logMetric": "Bhala Isilinganiso",
    "viewHistory": "Buka Umlando"
  },
  "aiInsights": {
    "title": "Ulwazi lwe-AI lwezeMpilo",
    "comingSoon": "Ulwazi lwakho luyahlanganiswa",
    "comingSoonDesc": "Gcwalisa ukuzihlola kwansuku zonke kanye noma kabili, sizobe sesikunikeza ulwazi oluqondiswe kuwe lapha.",
    "learnMore": "Funda kabanzi",
    "evidenceSources": {
      "WHO": "Kusekelwe kwiziqondiso ze-WHO",
      "NHS": "Sihambisana nezincomo ze-NHS",
      "CDC": "Sisekelwa iziqondiso ze-CDC",
      "RESEARCH": "Kusekelwe ocwaningweni olubuyekezwe ontanga",
      "CLINICAL": "Kusekelwa izifundo zemitholampilo"
    }
  },
  "dailyInsight": {
    "title": "Ulwazi lwezeMpilo lwaNsuku Zonke",
    "gettingStarted": "Ukuqalisa",
    "focus": "Okubalulekile",
    "quickInsight": "Ulwazi Olufushane",
    "simpleExplanation": "Incazelo Elula",
    "realLifeImpact": "Umthelela Empilweni Yoqobo",
    "yourActionStep": "Isinyathelo Okufanele Usithathe",
    "basedOnYour": "Kusekelwe ku-",
    "personalizedFor": "Kwenzelwe wena ngokusekelwe kudatha yakho yezempilo yakamuva",
    "getNewInsight": "Thola ulwazi olusha",
    "newInsightLoaded": "Ulwazi olusha lulayishiwe! 💡",
    "failedToRefresh": "Kuhluleke ukubuyekeza ulwazi",
    "priority": {
      "high": "Ake Sigxile Lapha",
      "medium": "Kufanele Ukunake"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Azikho izixwayiso zezempilo okwamanje",
    "noAlertsDesc": "Ugcina imikhuba emihle yempilo. Qhubeka njalo!",
    "whatYouCanDo": "Lokho ongakwenza:",
    "viewMealSuggestions": "Buka Iziphakamiso Zokudla Eziqondiswe Kuwe"
  },
  "engagement": {
    "currentStreak": "Ukulandelana Kwamanje",
    "bestStreak": "Ukulandelana Okuhle Kakhulu",
    "thisWeek": "Leli Viki",
    "exerciseDays": "Izinsuku Zokuzivocavoca",
    "hydrationDays": "Izinsuku Zokuphuza Amanzi",
    "healthMetricsLogged": "Izilinganiso Zezempilo Ezibhaliwe",
    "weeklyGoalsProgress": "Inqubekela-phambili Yemigomo Yeviki",
    "completed": "kuqediwe",
    "days": "izinsuku",
    "keepGoing": "Qhubeka njalo!",
    "personalRecord": "Irekhodi lakho siqu!",
    "goalMet": "Umgomo ufinyelelwe!"
  },
  "reminders": {
    "title": "Izikhumbuzi Zezempilo",
    "subtitle": "Hlala usendleleni ngezaziso zezempilo eziqondiswe kuwe",
    "breakfast": "Isikhumbuzi Sebhulakufasi",
    "lunch": "Isikhumbuzi Sedlo Lasemini",
    "dinner": "Isikhumbuzi Sedlo Sakusihlwa",
    "water": "Ukuphuza Amanzi",
    "movement": "Ikhefu Lokunyakaza",
    "sleep": "Isikhumbuzi Sokulala",
    "wellness": "Ukuzihlola Kwempilo",
    "healthLogging": "Ukubhala Imininingwane Yezempilo",
    "annualCheckup": "Ukuhlolwa Konyaka",
    "enable": "Vula",
    "disable": "Vala",
    "customize": "Hlela Isikhathi",
    "stayConsistent": "Hlala Ulandela Uhlelo ngezIzikhumbuzi Ezihlakaniphile",
    "setupFriendly": "Setha izikhumbuzi ezinomusa ukukusiza wakhe imikhuba emihle.",
    "customizeWhen": "Ungakhetha ukuthi uzithola nini futhi kangaki izikhumbuzi.",
    "supportive": "Ungakhathazeki - sizozenza zibe usizo futhi zingakuphazamisi! 💚",
    "noPreferences": "Azitholakalanga Izinketho Zezikhumbuzi",
    "noPreferencesDesc": "Asikwazanga ukulayisha izilungiselelo zakho zezikhumbuzi. Lokhu kungenzeka kungenxa yokuthi ungoqala lapha, noma kube nenkinga yokulayisha.",
    "retryLoading": "Zama Ukulayisha Futhi",
    "saveSettings": "Gcina Izilungiselelo",
    "saving": "Iyayigcina..."
  },
  "empty": {
    "startJourney": "Qala Uhambo Lwakho Lwempilo",
    "startJourneyDesc": "Qala uhambo lwakho lwezempilo namuhla! Yabelana ngokuthi uzizwa kanjani ukuze uthole ulwazi oluqondiswe kuwe futhi ulandelele impilo yakho.",
    "completeFirstCheckIn": "Gcwalisa Ukuzihlola Kokuqala",
    "stayOnTrack": "Hlala Usendleleni",
    "stayOnTrackDesc": "Hlala ulandela uhlelo lwakho 💊 Faka imithi yakho ukuze uthole izikhumbuzi ezimnene nosekelo.",
    "addFirstMedication": "Faka Umuthi Wokuqala",
    "learnMedicationSafety": "Funda Ngokuphepha Kwemithi",
    "buildMealLibrary": "Yakha Uhlu Lwakho Lwezidlo",
    "buildMealLibraryDesc": "Azikho izidlo ezintandokazi okwamanje. Gcina izidlo ozithandayo ukuze uzithole kalula futhi uhlele ukudla kalula.",
    "exploreMealOptions": "Hlola Izinketho Zokudla",
    "insightsAwait": "Ulwazi Lulindile",
    "insightsAwaitDesc": "Gcwalisa ukuzihlola kwansuku zonke futhi ulandelele impilo yakho ukuze uthole ulwazi lwezempilo nendlela impilo yakho eshintsha ngayo.",
    "startDailyCheckIn": "Qala Ukuzihlola Kwansuku Zonke",
    "learnAboutInsights": "Funda Ngolwazi Lwezempilo",
    "buildingStory": "Ukwakha Umlando Wakho Wempilo",
    "buildingStoryDesc": "Ayikho idatha yakudala okwamanje. Imikhuba nemiphumela yakho yezempilo izovela lapha uma uqhubeka nokuzihlola.",
    "completeCheckIn": "Gcwalisa Ukuzihlola",
    "tipComplete7Days": "Iseluleko: Gcwalisa ukuzihlola izinsuku ezingu-7 ukuze ubone imiphumela enembile.",
    "startTrackingHabits": "Qala Ukulandelela Imikhuba Emihle",
    "startTrackingHabitsDesc": "Abekho imikhuba elandelelwayo okwamanje. Izenzo ezincane zansuku zonke zidala ushintsho oluhlala njalo. Qala ukwakha indlela yakho yokuphila enempilo namuhla.",
    "trackFirstHabit": "Landelela Umkhuba Wokuqala",
    "getMoving": "Nyakazisa Umzimba",
    "getMovingDesc": "Awukho umsebenzi obhaliwe okwamanje. Ngisho nemizuzu eyi-10 yokunyakaza ingathuthukisa isimo sakho sengqondo namandla.",
    "logActivity": "Bhala Umsebenzi Womzimba",
    "allCaughtUp": "Konke Kuhambisana Nesikhathi!",
    "allCaughtUpDesc": "Awunazo izaziso ezintsha. Phinda uhlole emuva kwesikhathi ukuze uthole izibuyekezo nezikhumbuzi zempilo.",
    "noResultsFound": "Ayikho Imiphumela Etholiwe",
    "noResultsFoundDesc": "Asikwazanga ukuthola imiphumela ye-\"{query}\". Zama ukushintsha usesho lwakho noma uhlole ezinye izinketho."
  },
  "footer": {
    "tagline": "Umngane Wakho Wezempilo Olusizwa yi-AI",
    "builtWith": "Kwakhiwe ngokucophelela ngohambo lwakho lwezempilo",
    "allRightsReserved": "Wonke amalungelo agodliwe.",
    "about": "Mayelana nathi",
    "privacy": "Inqubomgomo yemfihlo",
    "terms": "Imigomo",
    "contact": "Xhumana nathi",
    "helpCenter": "Isikhungo Sosizo"
  },
  "modals": {
    "feedback": {
      "title": "Yabelana Ngombono Wakho",
      "subtitle": "Siza sithuthukise i-HealthLoop",
      "whatWorking": "Yini esebenza kahle?",
      "whatImprove": "Yini esingayithuthukisa?",
      "placeholder": "Bhala imicabango yakho...",
      "thankYou": "Siyabonga ngombono wakho!",
      "submitted": "Umbono wakho usisiza ukwenza i-HealthLoop ibe ngcono kakhulu."
    },
    "reportProblem": {
      "title": "Bika Inkinga",
      "subtitle": "Siza silungise amaphutha sithuthukise uhlelo",
      "describe": "Chaza inkinga",
      "placeholder": "Kwenzekeni? Sicela ucacise ngangokunokwenzeka...",
      "optional": "Ongakukhetha: Izinyathelo eziholele enkingeni",
      "stepsPlaceholder": "1. Ngichofoze ku...\n2. Ngase ngi...",
      "thankYou": "Siyabonga ngokubika!",
      "submitted": "Sizokubheka lokhu ngokushesha."
    },
    "mealPreferences": {
      "title": "Hlela Ukudla Kwakho",
      "subtitle": "Sitshele ngokudla okuthandayo",
      "cuisines": "Izinhlobo zokudla ozithandayo",
      "selectCuisines": "Khetha konke okusebenzayo",
      "dietary": "Izidingo zakho zokudla",
      "selectDietary": "Khetha izidingo zakho zokudla",
      "allergies": "Ukungezwani nokudla nezinye izinto",
      "allergiesPlaceholder": "isib. Amantongomane, Izinhlanzi, i-Gluten",
      "save": "Gcina Izinhlelo",
      "saving": "Iyasindisa..."
    },
    "upgrade": {
      "title": "Thuthukela ku-Premium",
      "subtitle": "Vula zonke izici",
      "features": "Izici ze-Premium",
      "getStarted": "Qala Manje",
      "learnMore": "Funda Kabanzi"
    }
  },
  "login": {
    "title": "Inkundla Yakho Yokuhlakanipha Kwezempilo",
    "subtitle": "Landelela, funda, uthathe isinyathelo ngaphambi kokuba izinkinga zikhule. Kwakhelwe ukuvimbela, ukufundisa, nokunakekela inhlalakahle.",
    "email": "I-imeyili",
    "password": "Iphasiwedi",
    "signIn": "Ngena",
    "signingIn": "Iyangena...",
    "forgotPassword": "Ukhohlwe Iphasiwedi?",
    "noAccount": "Awunayo i-akhawunti?",
    "createAccount": "Yenza entsha",
    "biometricLogin": "Ngena nge-Biometrics",
    "biometricHelper": "Sebenzisa iminwe (fingerprint), Face ID, noma Windows Hello",
    "authenticating": "Iyaqinisekisa...",
    "vendorPartner": "Ingabe unguzakwethu ohlinzeka ngezinsizakalo?",
    "vendorLogin": "Ukungena koHlinzekayo",
    "emailRequired": "Sicela ufake i-imeyili yakho kuqala",
    "biometricSuccess": "Ungene ngempumelelo nge-biometrics! 🎉",
    "noPasskeys": "Ayikho i-biometric emisiwe. Sicela usebenzise iphasiwedi kuqala.",
    "biometricCancelled": "Ukungena nge-biometric kuhoxisiwe",
    "biometricFailed": "Ukungena nge-biometric kwehlulekile. Sicela uzame iphasiwedi."
  },
  "register": {
    "title": "Joyina i-HealthLoop",
    "subtitle": "Qala uhambo lwakho lokuzivikela ezifweni namuhla",
    "fullName": "Igama Eliphelele",
    "email": "I-imeyili",
    "password": "Iphasiwedi",
    "confirmPassword": "Qinisekisa Iphasiwedi",
    "createAccount": "Vula I-akhawunti",
    "haveAccount": "Usuvele unayo i-akhawunti?",
    "signIn": "Ngena",
    "creating": "Ivula i-akhawunti...",
    "passwordTooShort": "Iphasiwedi kumele ibe nezinhlamvu okungenani eziyisi-8",
    "setupBiometric": "Hlela Ukungena nge-Biometric",
    "setupBiometricDesc": "Sebenzisa iminwe yakho, Face ID, noma Windows Hello ukuze ungene ngokushesha nangokuphepha",
    "setupNow": "Hlela i-Biometric Manje",
    "skipForNow": "Yeqa okwamanje",
    "settingUp": "Iyahlela...",
    "benefit1": "Ngeke kusadingeka ukhumbule amaphasiwedi",
    "benefit2": "Kuphephe kakhulu ngokuqinisekisa nge-biometric",
    "benefit3": "Ngena ngokuthepha nje noma ngokubheka isikrini",
    "biometricPrivacy": "Imininingwane yakho ye-biometric ayisoze yaphuma kule divayisi",
    "biometricSuccess": "Ukungena nge-biometric kuhlelwe ngempumelelo! 🎉",
    "biometricFailed": "Kwehlulekile ukuhlela i-biometric. Ungakwenza lokhu emuva kwesikhathi kuzilungiselelo.",
    "biometricSetupLater": "Ungahlela ukungena nge-biometric emuva kwesikhathi kuzilungiselelo zakho"
  },
  "womensHealthPage": {
    "title": "Ukulandelela Impilo Yabesifazane",
    "subtitle": "Landelela isikhathi sakho sokuya ocansini, izimpawu, nokuphila kahle",
    "cycleOverview": "Isifinyezo Sesikhathi Senyanga",
    "currentPhase": "Isigaba Samanje",
    "nextPeriod": "Isikhathi Esilandelayo Esilindelekile",
    "logPeriod": "Faka Isikhathi Senyanga",
    "logSymptoms": "Faka Izimpawu",
    "insights": "Ulwazi Ngesikhathi Senyanga",
    "tips": "Amathiphu Alingana Nesigaba",
    "history": "Umlando Wezikhathi Zenyanga",
    "noData": "Ayikho idatha okwamanje",
    "noDataDesc": "Qala ukulandelela isikhathi sakho ukuze uthole ulwazi nezibikezelo ezenzelwe wena.",
    "startTracking": "Qala Ukulandelela"
  },
  "notifications": {
    "title": "Izaziso",
    "markAllRead": "Marka Konke Njengokufundiwe",
    "noNotifications": "Azikho izaziso ezintsha",
    "viewAll": "Buka Konke"
  },
  "familyHealth": {
    "title": "Impilo Yomndeni Nezingane",
    "subtitle": "Ukwesekwa kokuvikela izifo emndenini wakho wonke",
    "tabImmunizations": "Imigomo",
    "tabEducation": "Imfundo",
    "tabReminders": "Izikhumbuzi",
    "tabPlanner": "Umhleli Womndeni",
    "immunizations": {
      "title": "Ukuqwashisa Ngemigomo",
      "subtitle": "Hlala unolwazi mayelana nemigomo ephakanyiswayo",
      "recommendedSchedule": "Uhlelo Olunconywayo",
      "byAge": "Ngamaqoqo Emisindo",
      "infants": "Izinsana (0-12 izinyanga)",
      "toddlers": "Izingane (1-3 iminyaka)",
      "preschool": "Inkulisa (4-6 iminyaka)",
      "schoolAge": "Iminyaka Yesikole (7-12 iminyaka)",
      "teens": "Intsha (13-18 iminyaka)",
      "adults": "Abadala",
      "learnMore": "Funda Kabanzi",
      "consultDoctor": "Ngaso sonke isikhathi thintana nomeluleki wezempilo ukuze uthole izincomo zemigomo ezenzelwe wena",
      "upcomingReminders": "Izikhumbuzi Zemigomo Ezizayo",
      "noReminders": "Azikho izaziso zemigomo ezizayo",
      "addReminder": "Faka Isikhumbuzi Somgomo",
      "reminderFor": "Isikhumbuzi sika-",
      "dueDate": "Usuku Okufanele Ngalo",
      "notes": "Amanothi",
      "markComplete": "Marka njengokuqediwe"
    },
    "education": {
      "title": "Imfundo Yezempilo Yomndeni",
      "subtitle": "Ulwazi lokuvikela izifo olusekelwe ebufakazini",
      "categories": "Izigaba",
      "infant": "Ukunakekelwa Kwezinsana",
      "child": "Ukukhula Kwengane",
      "nutrition": "Ukudla Nokukhula",
      "safety": "Ukuphepha Nokuvikeleka",
      "mental": "Inhlalakahle Yengqondo",
      "hygiene": "Inhlanzeko Nemikhuba",
      "searchPlaceholder": "Sesha izihloko zezempilo...",
      "popularTopics": "Izihloko Ezithandwayo",
      "readMore": "Funda Kabanzi",
      "readTime": "imizuzu yokufunda"
    },
    "reminders": {
      "title": "Izikhumbuzi Zezempilo Zomndeni",
      "subtitle": "Hlala usendleleni ngokunakekelwa kokuvikela umndeni wonke",
      "createReminder": "Yenza Isikhumbuzi",
      "familyMember": "Ilungu Lomndeni",
      "reminderType": "Uhlobo Lesikhumbuzi",
      "frequency": "Imvamisa",
      "activeReminders": "Izikhumbuzi Ezisebenzayo",
      "upcomingThisWeek": "Ezizayo Kuleli sonto",
      "noActiveReminders": "Azikho izaziso ezisebenzayo",
      "types": {
        "checkup": "Ukuhlolwa Kwezempilo",
        "dental": "Ukuvakashela Udokotela Wamazinyo",
        "vision": "Ukuhlolwa Kwamehlo",
        "vaccine": "Umjovo Womgomo",
        "medication": "Imithi",
        "custom": "Okunye"
      }
    },
    "planner": {
      "title": "Umhleli Wezempilo Yomndeni",
      "subtitle": "Hlela ukunakekelwa kokuvikela umndeni wakho",
      "addMember": "Faka Ilungu Lomndeni",
      "memberName": "Igama Lelungu",
      "relationship": "Ubudlelwane",
      "dateOfBirth": "Usuku Lokuzalwa",
      "viewCalendar": "Buka Ikhalenda",
      "upcomingCare": "Ukunakekelwa Kokuvikela Okuzayo",
      "nothingScheduled": "Akukho okuhleliwe okwamanje",
      "scheduleCheckup": "Hlela Ukuhlolwa",
      "relationships": {
        "child": "Ingane",
        "spouse": "Oshade naye",
        "parent": "Umzali",
        "sibling": "Ingane yakwethu",
        "other": "Okunye"
      }
    },
    "content": {
      "infantCare": {
        "title": "Ukunakekelwa Kokuvikela Izinsana",
        "intro": "Imikhuba ebalulekile yokuvikela impilo yonyaka wokuqala wengane yakho",
        "topics": [
          "Uhlelo lokuhlola ingane",
          "Izinyathelo zokukhula okufanele uzibheke",
          "Imikhuba yokulala ephephile",
          "Ukudla nokuncelisa",
          "Uhlelo lwemigomo"
        ]
      },
      "childDevelopment": {
        "title": "Ukukhula Kwengane Nezigaba Zayo",
        "intro": "Ukuqonda ukukhula nokuthuthuka okunempilo",
        "topics": [
          "Izigaba zokukhula komzimba",
          "Ukukhula komphakathi nemizwa",
          "Ukuthuthuka kolimi",
          "Izigaba zokuqonda",
          "Ukuthi ungakhuluma nini nodokotela"
        ]
      },
      "nutrition": {
        "title": "Ukudla Nokukhula Okunempilo",
        "intro": "Ukwakha imikhuba yokudla okunempilo kusukela ekuqaleni",
        "topics": [
          "Ukudla okufanele iminyaka yabo",
          "Imibono yokudla okulula okunempilo",
          "Ukuphatha izingane ezikhetha ukudla",
          "Izisekelo zokuphepha kokudla",
          "Imihlahlandlela yokuphuza amanzi"
        ]
      },
      "safety": {
        "title": "Ukuphepha Nokuvimbela Ukulimala",
        "intro": "Ukwenza indawo ephephile yomndeni wakho",
        "topics": [
          "Uhlu lokubheka ukuphepha ekhaya",
          "Ukuphepha kwesihlalo semoto",
          "Ukuphepha emanzini",
          "Ukuvimbela ubuthi",
          "Ukuzilungiselela isimo esiphuthumayo"
        ]
      }
    }
  }
};
